// // // import React, { useState, useRef, useEffect } from "react";

// // // export default function RichTextEditor({
// // //   editor,
// // //   editorContent,
// // //   showtoolbar,
// // //   onChange,
// // //   readOnly,
// // //   minHeight,
// // //   maxHeight,
// // //   editorId
// // // }) {
// // //   const [findText, setFindText] = useState("");
// // //   const [showFindBar, setShowFindBar] = useState(false);
// // //   const [activeFormats, setActiveFormats] = useState({});
// // //   const [activeHeadings, setActiveHeadings] = useState({
// // //     h1: false,
// // //     h2: false,
// // //   });

// // //   const executeCommand = (command, value = null) => {
// // //     editor.current.focus();
// // //     document.execCommand(command, false, value);
// // //     updateActiveFormats();
// // //   };

// // //   useEffect(() => {
// // //     if (readOnly) return;
// // //     const el = editor.current;
// // //     if (!el) return;

// // //     el.addEventListener("click", (e) => {
// // //       if (e.target.tagName === "IMG") {
// // //         el.querySelectorAll("img").forEach((img) =>
// // //           img.classList.remove("selected")
// // //         );
// // //         e.target.classList.add("selected");
// // //         enableResize(e.target);
// // //       }
// // //     });
// // //   }, [readOnly]);

// // //   const enableResize = (img) => {
// // //     let isResizing = false;
// // //     let startX, startWidth;

// // //     img.addEventListener("mousedown", (e) => {
// // //       const rect = img.getBoundingClientRect();
// // //       // Only start resizing near bottom-right corner
// // //       if (e.clientX > rect.right - 10 && e.clientY > rect.bottom - 10) {
// // //         isResizing = true;
// // //         startX = e.clientX;
// // //         startWidth = rect.width;
// // //         e.preventDefault();
// // //       }
// // //     });

// // //     document.addEventListener("mousemove", (e) => {
// // //       if (!isResizing) return;
// // //       const newWidth = startWidth + (e.clientX - startX);
// // //       img.style.width = newWidth + "px";
// // //       img.style.height = "auto"; // keep ratio
// // //     });

// // //     document.addEventListener("mouseup", () => {
// // //       isResizing = false;
// // //     });
// // //   };

// // //   const updateActiveFormats = () => {
// // //     setActiveFormats({
// // //       bold: document.queryCommandState("bold"),
// // //       italic: document.queryCommandState("italic"),
// // //       underline: document.queryCommandState("underline"),
// // //       strikeThrough: document.queryCommandState("strikeThrough"),
// // //       superscript: document.queryCommandState("superscript"),
// // //       subscript: document.queryCommandState("subscript"),
// // //       insertUnorderedList: document.queryCommandState("insertUnorderedList"),
// // //       insertOrderedList: document.queryCommandState("insertOrderedList"),
// // //     });
// // //   };

// // //   const insertLink = () => {
// // //     const selection = window.getSelection();
// // //     if (selection.rangeCount === 0) {
// // //       alert("Please select some text first");
// // //       return;
// // //     }

// // //     const url = prompt("Enter URL:", "https://");
// // //     if (url && url.trim() !== "" && url !== "https://") {
// // //       executeCommand("createLink", url);
// // //     }
// // //   };

// // //   const insertImage = () => {
// // //     const fileInput = document.createElement("input");
// // //     fileInput.type = "file";
// // //     fileInput.accept = "image/*"; // only image files
// // //     fileInput.style.display = "none";

// // //     fileInput.onchange = (e) => {
// // //       const file = e.target.files[0];
// // //       if (!file) return;
// // //       const reader = new FileReader();
// // //       reader.onload = (ev) => {
// // //         const base64Image = ev.target.result;
// // //         // Insert at cursor position
// // //         editor.current.focus();
// // //         document.execCommand("insertImage", false, base64Image);
// // //       };
// // //       reader.readAsDataURL(file); // Convert to Base64
// // //     };
// // //     document.body.appendChild(fileInput);
// // //     fileInput.click();
// // //     document.body.removeChild(fileInput);
// // //   };

// // //   const handleUndo = () => {
// // //     executeCommand("undo");
// // //   };

// // //   const handleRedo = () => {
// // //     executeCommand("redo");
// // //   };

// // //   const formatHeading = (level) => {
// // //     const key = `h${level}`;

// // //     if (activeHeadings[key]) {
// // //       // Reset to normal
// // //       executeCommand("fontSize", "3"); // Normal size
// // //       executeCommand("bold"); // Remove bold
// // //       setActiveHeadings({ ...activeHeadings, [key]: false });
// // //     } else {
// // //       // Apply heading format
// // //       executeCommand("fontSize", level === 1 ? "7" : "6");
// // //       executeCommand("bold");
// // //       setActiveHeadings({ ...activeHeadings, [key]: true });
// // //     }
// // //   };

// // //   const handleFind = () => {
// // //     if (findText) {
// // //       window.find(findText);
// // //     }
// // //   };

// // //   const handleCopy = () => {
// // //     document.execCommand("copy");
// // //   };

// // //   const handlePaste = async () => {
// // //     try {
// // //       const text = await navigator.clipboard.readText();
// // //       executeCommand("insertText", text);
// // //     } catch (err) {
// // //       console.error("Failed to paste:", err);
// // //     }
// // //   };

// // //   return (
// // //     <div className="editor-container">
// // //       <style>{`
// // //         @import url('https://fonts.googleapis.com/icon?family=Material+Icons');

// // //         * {
// // //           margin: 0;
// // //           padding: 0;
// // //           box-sizing: border-box;
// // //         }

// // //         body {
// // //           font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
// // //           background: #f5f5f5;
// // //         }

// // //         .editor-container {
// // //         //   max-width: 900px;
// // //         //   margin: 20px auto;
// // //           background: white;
// // //           border-radius: 8px;
// // //           box-shadow: 0 2px 8px rgba(0,0,0,0.1);
// // //           overflow: hidden;
// // //         }

// // //         .toolbar {
// // //           display: flex;
// // //           flex-wrap: wrap;
// // //           gap: 4px;
// // //           padding: 12px;
// // //           background: #f8f9fa;
// // //           border-bottom: 1px solid #dee2e6;
// // //         }

// // //         .toolbar-group {
// // //           display: flex;
// // //           gap: 4px;
// // //           padding-right: 8px;
// // //           border-right: 1px solid #dee2e6;
// // //         }

// // //         .toolbar-group:last-child {
// // //           border-right: none;
// // //         }

// // //         .toolbar-btn {
// // //           display: flex;
// // //           align-items: center;
// // //           justify-content: center;
// // //           width: 36px;
// // //           height: 36px;
// // //           border: 1px solid #dee2e6;
// // //           background: white;
// // //           border-radius: 4px;
// // //           cursor: pointer;
// // //           transition: all 0.2s;
// // //           color: #495057;
// // //         }

// // //         .toolbar-btn:hover {
// // //           background: #e9ecef;
// // //           border-color: #adb5bd;
// // //         }

// // //         .toolbar-btn:active {
// // //           background: #dee2e6;
// // //         }

// // //         .toolbar-btn.active {
// // //           background: #1976d2;
// // //           color: white;
// // //           border-color: #1976d2;
// // //         }

// // //         .toolbar-btn.active:hover {
// // //           background: #1565c0;
// // //           border-color: #1565c0;
// // //         }

// // //         .material-icons {
// // //           font-size: 20px;
// // //           user-select: none;
// // //         }

// // //         .find-bar {
// // //           display: flex;
// // //           gap: 8px;
// // //           padding: 12px;
// // //           background: #fff3cd;
// // //           border-bottom: 1px solid #ffc107;
// // //           align-items: center;
// // //         }

// // //         .find-input {
// // //           flex: 1;
// // //           padding: 8px 12px;
// // //           border: 1px solid #dee2e6;
// // //           border-radius: 4px;
// // //           font-size: 14px;
// // //         }

// // //         .find-btn {
// // //           padding: 8px 16px;
// // //           background: #1976d2;
// // //           color: white;
// // //           border: none;
// // //           border-radius: 4px;
// // //           cursor: pointer;
// // //           font-size: 14px;
// // //           font-weight: 500;
// // //         }

// // //         .find-btn:hover {
// // //           background: #1565c0;
// // //         }

// // //         .close-btn {
// // //           padding: 8px 16px;
// // //           background: #6c757d;
// // //           color: white;
// // //           border: none;
// // //           border-radius: 4px;
// // //           cursor: pointer;
// // //           font-size: 14px;
// // //           font-weight: 500;
// // //         }

// // //         .close-btn:hover {
// // //           background: #545b62;
// // //         }

// // //         .editor-area-1 {
// // //           min-height: 460px !important;
// // //           max-height: 460px !important;
// // //           overflow-x: scroll;
// // //           overflow-y: scroll;
// // //           padding: 20px;
// // //           outline: none;
// // //           font-size: 16px;
// // //           line-height: 1.6;
// // //           color: #212529;
// // //           direction: ltr !important;
// // //           unicode-bidi: plaintext !important;
// // //         }

// // //         .editor-area-2 {
// // //           min-height: 450px !important;
// // //           max-height: 450px !important;
// // //           overflow-x: hidden;
// // //           overflow-y: auto;
// // //           padding: 20px;
// // //           outline: none;
// // //           font-size: 16px;
// // //           line-height: 1.6;
// // //           color: #212529;
// // //           direction: ltr !important;
// // //           unicode-bidi: plaintext !important;
// // //         }

// // //         .editor-area:focus {
// // //           outline: 2px solid #1976d2;
// // //           outline-offset: -2px;
// // //         }

// // //         .editor-area h1 {
// // //           font-size: 2em;
// // //           font-weight: bold;
// // //           margin: 0.67em 0;
// // //         }

// // //         .editor-area h2 {
// // //           font-size: 1.5em;
// // //           font-weight: bold;
// // //           margin: 0.75em 0;
// // //         }

// // //         .editor-area img {
// // //           max-width: 100%;
// // //           height: auto;
// // //           margin: 10px 0;
// // //         }

// // //         .editor-area a {
// // //           color: #1976d2;
// // //           text-decoration: underline;
// // //         }
        
// // //         .editor-area img {
// // //           max-width: 100%;
// // //           height: auto;
// // //           border: 1px solid transparent;
// // //           padding: 2px;
// // //         }

// // //         /* Show resize handle */
// // //         .editor-area img.selected {
// // //           outline: 2px solid #1976d2;
// // //           position: relative;
// // //         }

// // //         .editor-area img.selected::after {
// // //           content: "";
// // //           position: absolute;
// // //           bottom: -4px;
// // //           right: -4px;
// // //           width: 12px;
// // //           height: 12px;
// // //           background: #1976d2;
// // //           cursor: nwse-resize;
// // //           border-radius: 2px;
// // //         }

// // //         @media (max-width: 768px) {
// // //           .editor-container {
// // //             margin: 10px;
// // //           }

// // //           .toolbar {
// // //             gap: 2px;
// // //             padding: 1px;
// // //           }

// // //           .toolbar-btn {
// // //             width: 32px;
// // //             height: 28px;
// // //           }

// // //           .material-icons {
// // //             font-size: 18px;
// // //           }

// // //           /* View Only / Preview Mode */
// // // .editor-area.view-only {
// // //   border: none !important;
// // //   outline: none !important;
// // //   background: white !important;
// // //   padding: 10px 20px; /* cleaner margin */
// // //   cursor: default !important;
// // //   pointer-events: auto; /* allow text selection */
// // // }

// // // /* No resize handles in Preview */
// // // .editor-area.view-only img {
// // //   outline: none !important;
// // //   cursor: default !important;
// // // }

// // // .editor-area.view-only img::after {
// // //   display: none !important;
// // // }

// // // /* Remove Scroll bar look */
// // // .editor-area.view-only::-webkit-scrollbar {
// // //   width: 6px;
// // // }

// // // .editor-area.view-only::-webkit-scrollbar-thumb {
// // //   background: transparent;
// // // }
// // //         }
// // //       `}</style>

// // //       {showtoolbar && !readOnly && (
// // //         <div className="toolbar">
// // //           <div className="toolbar-group">
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={handleUndo}
// // //               title="Undo (Ctrl+Z)"
// // //             >
// // //               <span className="material-icons">undo</span>
// // //             </button>
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={handleRedo}
// // //               title="Redo (Ctrl+Y)"
// // //             >
// // //               <span className="material-icons">redo</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className={`toolbar-btn ${activeHeadings.h1 ? "active" : ""}`}
// // //               onClick={() => formatHeading(1)}
// // //               title="Heading 1"
// // //             >
// // //               <span className="material-icons">looks_one</span>
// // //             </button>
// // //             <button
// // //               className={`toolbar-btn ${activeHeadings.h2 ? "active" : ""}`}
// // //               onClick={() => formatHeading(2)}
// // //               title="Heading 2"
// // //             >
// // //               <span className="material-icons">looks_two</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className={`toolbar-btn ${activeFormats.bold ? "active" : ""}`}
// // //               onClick={() => executeCommand("bold")}
// // //               title="Bold (Ctrl+B)"
// // //             >
// // //               <span className="material-icons">format_bold</span>
// // //             </button>
// // //             <button
// // //               className={`toolbar-btn ${activeFormats.italic ? "active" : ""}`}
// // //               onClick={() => executeCommand("italic")}
// // //               title="Italic (Ctrl+I)"
// // //             >
// // //               <span className="material-icons">format_italic</span>
// // //             </button>
// // //             <button
// // //               className={`toolbar-btn ${
// // //                 activeFormats.underline ? "active" : ""
// // //               }`}
// // //               onClick={() => executeCommand("underline")}
// // //               title="Underline (Ctrl+U)"
// // //             >
// // //               <span className="material-icons">format_underlined</span>
// // //             </button>
// // //             <button
// // //               className={`toolbar-btn ${
// // //                 activeFormats.strikeThrough ? "active" : ""
// // //               }`}
// // //               onClick={() => executeCommand("strikeThrough")}
// // //               title="Strikethrough"
// // //             >
// // //               <span className="material-icons">strikethrough_s</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className={`toolbar-btn ${
// // //                 activeFormats.superscript ? "active" : ""
// // //               }`}
// // //               onClick={() => executeCommand("superscript")}
// // //               title="Superscript"
// // //             >
// // //               <span className="material-icons">superscript</span>
// // //             </button>
// // //             <button
// // //               className={`toolbar-btn ${
// // //                 activeFormats.subscript ? "active" : ""
// // //               }`}
// // //               onClick={() => executeCommand("subscript")}
// // //               title="Subscript"
// // //             >
// // //               <span className="material-icons">subscript</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className={`toolbar-btn ${
// // //                 activeFormats.insertUnorderedList ? "active" : ""
// // //               }`}
// // //               onClick={(e) => {
// // //                 e.preventDefault();
// // //                 executeCommand("insertUnorderedList");
// // //               }}
// // //               title="Unordered List"
// // //             >
// // //               <span className="material-icons">format_list_bulleted</span>
// // //             </button>
// // //             <button
// // //               className={`toolbar-btn ${
// // //                 activeFormats.insertOrderedList ? "active" : ""
// // //               }`}
// // //               onClick={(e) => {
// // //                 e.preventDefault();
// // //                 executeCommand("insertOrderedList");
// // //               }}
// // //               title="Ordered List"
// // //             >
// // //               <span className="material-icons">format_list_numbered</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={() => executeCommand("justifyLeft")}
// // //               title="Align Left"
// // //             >
// // //               <span className="material-icons">format_align_left</span>
// // //             </button>
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={() => executeCommand("justifyCenter")}
// // //               title="Align Center"
// // //             >
// // //               <span className="material-icons">format_align_center</span>
// // //             </button>
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={() => executeCommand("justifyRight")}
// // //               title="Align Right"
// // //             >
// // //               <span className="material-icons">format_align_right</span>
// // //             </button>
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={() => executeCommand("justifyFull")}
// // //               title="Justify"
// // //             >
// // //               <span className="material-icons">format_align_justify</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={(e) => {
// // //                 e.preventDefault();
// // //                 insertLink();
// // //               }}
// // //               title="Insert Link"
// // //             >
// // //               <span className="material-icons">link</span>
// // //             </button>
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={(e) => {
// // //                 e.preventDefault();
// // //                 insertImage();
// // //               }}
// // //               title="Insert Image"
// // //             >
// // //               <span className="material-icons">image</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={(e) => {
// // //                 e.preventDefault();
// // //                 executeCommand("removeFormat");
// // //               }}
// // //               title="Clear Formatting"
// // //             >
// // //               <span className="material-icons">format_clear</span>
// // //             </button>
// // //           </div>

// // //           <div className="toolbar-group">
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={() => setShowFindBar(!showFindBar)}
// // //               title="Find (Ctrl+F)"
// // //             >
// // //               <span className="material-icons">search</span>
// // //             </button>
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={handleCopy}
// // //               title="Copy (Ctrl+C)"
// // //             >
// // //               <span className="material-icons">content_copy</span>
// // //             </button>
// // //             <button
// // //               className="toolbar-btn"
// // //               onClick={handlePaste}
// // //               title="Paste (Ctrl+V)"
// // //             >
// // //               <span className="material-icons">content_paste</span>
// // //             </button>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {showFindBar && (
// // //         <div className="find-bar">
// // //           <input
// // //             type="text"
// // //             className="find-input"
// // //             placeholder="Find text..."
// // //             value={findText}
// // //             onChange={(e) => setFindText(e.target.value)}
// // //             onKeyPress={(e) => e.key === "Enter" && handleFind()}
// // //           />
// // //           <button className="find-btn" onClick={handleFind}>
// // //             Find
// // //           </button>
// // //           <button className="close-btn" onClick={() => setShowFindBar(false)}>
// // //             Close
// // //           </button>
// // //         </div>
// // //       )}

// // //       <div
// // //         ref={editor}
// // //         className={`editor-area-${editorId} ${readOnly ? "view-only" : ""}`}
// // //         contentEditable={!readOnly}
// // //         suppressContentEditableWarning
// // //         onMouseUp={!readOnly ? updateActiveFormats : undefined}
// // //         onKeyUp={!readOnly ? updateActiveFormats : undefined}
// // //         onClick={!readOnly ? updateActiveFormats : undefined}
// // //         onInput={!readOnly ? onChange : undefined}
// // //       >
// // //         {editorContent}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // import React, { useState, useRef, useEffect } from "react";
// // import { withStyles } from "@material-ui/core/styles";
// // import Tooltip from "@material-ui/core/Tooltip";
// // import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// // import { IconButton } from "@material-ui/core";
// // import { Button } from "@mui/material";
// // import paraphrase_logo from "../../static/Paraphrase 1.png";
// // import paraphrase_Gray from "../../static/Paraphrase 2.png";
// // import { FaBookOpen } from "react-icons/fa";
// // import { Spellcheck } from "@mui/icons-material";
// // import { Delete } from "@mui/icons-material";
// // import UploadIcon from "@mui/icons-material/Upload";
// // import MicIcon from "@mui/icons-material/Mic";
// // import DownloadIcon from "@mui/icons-material/Download";
// // import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// // import TranslateIcon from "@mui/icons-material/Translate";

// // const CustomTooltip = withStyles((theme) => ({
// //   tooltip: {
// //     backgroundColor: theme.palette.common.white,
// //     color: "blue",
// //     boxShadow: theme.shadows[1],
// //     fontSize: 11,
// //   },
// // }))(Tooltip);

// // export default function RichTextEditor({
// //   editor,
// //   editorContent,
// //   showtoolbar,
// //   onChange,
// //   readOnly,
// //   minHeight,
// //   maxHeight,
// //   editorId,
// //   placeholder,
// //   isGrammarCheck,
// //   mobileView,
// //   totalWords,
// //   accessToParaphrase,
// //   handleParaphraseClick,
// //   accessToSummarize,
// //   handleSummariserClick,
// //   accessToOCR,
// //   accessToDelete,
// //   handleDeleteFormain,
// //   accessToUpload,
// //   handleFileChange,
// //   docId,
// //   handleCopyFormain,
// //   accessToTranslate,
// //   handleTranslateClick,
// //   isRecording,
// //   handleMicClick,
// //   ocrCheck,
// //   grammarCheckClick,
// //   openDownloadModal,
// //   isEditorOnly = false,
// //   onMount,
// // }) {
// //   const [findText, setFindText] = useState("");
// //   const [showFindBar, setShowFindBar] = useState(false);
// //   const [activeFormats, setActiveFormats] = useState({});
// //   const [activeHeadings, setActiveHeadings] = useState({
// //     h1: false,
// //     h2: false,
// //   });
// //   const toCssSize = (value, fallback) =>
// //     typeof value === "number" ? `${value}px` : value || fallback;
// //   const editorMinHeight = toCssSize(minHeight, "480px");
// //   const editorMaxHeight = toCssSize(maxHeight, "465px");

// //   const executeCommand = (command, value = null) => {
// //     editor.current.focus();
// //     document.execCommand(command, false, value);
// //     updateActiveFormats();
// //   };

// //   // useEffect(() => {
// //   //   if (editor.current && onMount) {
// //   //     onMount(editor.current);
// //   //   }
// //   // }, []);

// //   useEffect(() => {
// //     if (readOnly) return;
// //     const el = editor.current;
// //     if (!el) return;

// //     el.addEventListener("click", (e) => {
// //       if (e.target.tagName === "IMG") {
// //         el.querySelectorAll("img").forEach((img) =>
// //           img.classList.remove("selected")
// //         );
// //         e.target.classList.add("selected");
// //         enableResize(e.target);
// //       }
// //     });
// //   }, [readOnly]);

// //   // useEffect(() => {
// //   //   console.log("editorContent_",editor)
// //   //   if (editor.current && editorContent !== editor.current.innerHTML) {
// //   //     editor.current.innerHTML = editorContent || "";
// //   //   }
// //   // }, [editorContent]);

// //   const enableResize = (img) => {
// //     let isResizing = false;
// //     let startX, startWidth;

// //     img.addEventListener("mousedown", (e) => {
// //       const rect = img.getBoundingClientRect();
// //       // Only start resizing near bottom-right corner
// //       if (e.clientX > rect.right - 10 && e.clientY > rect.bottom - 10) {
// //         isResizing = true;
// //         startX = e.clientX;
// //         startWidth = rect.width;
// //         e.preventDefault();
// //       }
// //     });

// //     document.addEventListener("mousemove", (e) => {
// //       if (!isResizing) return;
// //       const newWidth = startWidth + (e.clientX - startX);
// //       img.style.width = newWidth + "px";
// //       img.style.height = "auto"; // keep ratio
// //     });

// //     document.addEventListener("mouseup", () => {
// //       isResizing = false;
// //     });
// //   };

// //   const updateActiveFormats = () => {
// //     setActiveFormats({
// //       bold: document.queryCommandState("bold"),
// //       italic: document.queryCommandState("italic"),
// //       underline: document.queryCommandState("underline"),
// //       strikeThrough: document.queryCommandState("strikeThrough"),
// //       superscript: document.queryCommandState("superscript"),
// //       subscript: document.queryCommandState("subscript"),
// //       insertUnorderedList: document.queryCommandState("insertUnorderedList"),
// //       insertOrderedList: document.queryCommandState("insertOrderedList"),
// //     });
// //   };

// //   const insertLink = () => {
// //     const selection = window.getSelection();
// //     if (selection.rangeCount === 0) {
// //       alert("Please select some text first");
// //       return;
// //     }

// //     const url = prompt("Enter URL:", "https://");
// //     if (url && url.trim() !== "" && url !== "https://") {
// //       executeCommand("createLink", url);
// //     }
// //   };

// //   const insertImage = () => {
// //     const fileInput = document.createElement("input");
// //     fileInput.type = "file";
// //     fileInput.accept = "image/*"; // only image files
// //     fileInput.style.display = "none";

// //     fileInput.onchange = (e) => {
// //       const file = e.target.files[0];
// //       if (!file) return;
// //       const reader = new FileReader();
// //       reader.onload = (ev) => {
// //         const base64Image = ev.target.result;
// //         // Insert at cursor position
// //         editor.current.focus();
// //         document.execCommand("insertImage", false, base64Image);
// //       };
// //       reader.readAsDataURL(file); // Convert to Base64
// //     };
// //     document.body.appendChild(fileInput);
// //     fileInput.click();
// //     document.body.removeChild(fileInput);
// //   };

// //   const handleUndo = () => {
// //     executeCommand("undo");
// //   };

// //   const handleRedo = () => {
// //     executeCommand("redo");
// //   };

// //   const formatHeading = (level) => {
// //     const key = `h${level}`;

// //     if (activeHeadings[key]) {
// //       // Reset to normal
// //       executeCommand("fontSize", "3"); // Normal size
// //       executeCommand("bold"); // Remove bold
// //       setActiveHeadings({ ...activeHeadings, [key]: false });
// //     } else {
// //       // Apply heading format
// //       executeCommand("fontSize", level === 1 ? "7" : "6");
// //       executeCommand("bold");
// //       setActiveHeadings({ ...activeHeadings, [key]: true });
// //     }
// //   };

// //   const handleFind = () => {
// //     if (findText) {
// //       window.find(findText);
// //     }
// //   };

// //   const handleCopy = () => {
// //     document.execCommand("copy");
// //   };

// //   const handlePaste = async () => {
// //     try {
// //       const text = await navigator.clipboard.readText();
// //       executeCommand("insertText", text);
// //     } catch (err) {
// //       console.error("Failed to paste:", err);
// //     }
// //   };

// //   return (
// //     <div className="editor-container">
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/icon?family=Material+Icons');

// //         * {
// //           margin: 0;
// //           padding: 0;
// //           box-sizing: border-box;
// //         }

// //         body {
// //           font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
// //           background: #f5f5f5;
// //         }

// //         .editor-container {
// //         //   max-width: 900px;
// //         //   margin: 20px auto;
// //           background: white;
// //           border-radius: 8px;
// //           box-shadow: 0 2px 8px rgba(0,0,0,0.1);
// //           overflow: hidden;
// //         }

// //         .toolbar {
// //           display: flex;
// //           flex-wrap: wrap;
// //           gap: 4px;
// //           padding: 12px;
// //           background: #f8f9fa;
// //           border-bottom: 1px solid #dee2e6;
// //         }

// //         .toolbar-group {
// //           display: flex;
// //           gap: 4px;
// //           padding-right: 8px;
// //           border-right: 1px solid #dee2e6;
// //         }

// //         .toolbar-group:last-child {
// //           border-right: none;
// //         }

// //         .toolbar-btn {
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           width: 36px;
// //           height: 36px;
// //           border: 1px solid #dee2e6;
// //           background: white;
// //           border-radius: 4px;
// //           cursor: pointer;
// //           transition: all 0.2s;
// //           color: #495057;
// //         }

// //         .toolbar-btn:hover {
// //           background: #e9ecef;
// //           border-color: #adb5bd;
// //         }

// //         .toolbar-btn:active {
// //           background: #dee2e6;
// //         }

// //         .toolbar-btn.active {
// //           background: #1976d2;
// //           color: white;
// //           border-color: #1976d2;
// //         }

// //         .toolbar-btn.active:hover {
// //           background: #1565c0;
// //           border-color: #1565c0;
// //         }

// //         .material-icons {
// //           font-size: 20px;
// //           user-select: none;
// //         }

// //         .find-bar {
// //           display: flex;
// //           gap: 8px;
// //           padding: 12px;
// //           background: #fff3cd;
// //           border-bottom: 1px solid #ffc107;
// //           align-items: center;
// //         }

// //         .find-input {
// //           flex: 1;
// //           padding: 8px 12px;
// //           border: 1px solid #dee2e6;
// //           border-radius: 4px;
// //           font-size: 14px;
// //         }

// //         .find-btn {
// //           padding: 8px 16px;
// //           background: #1976d2;
// //           color: white;
// //           border: none;
// //           border-radius: 4px;
// //           cursor: pointer;
// //           font-size: 14px;
// //           font-weight: 500;
// //         }

// //         .find-btn:hover {
// //           background: #1565c0;
// //         }

// //         .close-btn {
// //           padding: 8px 16px;
// //           background: #6c757d;
// //           color: white;
// //           border: none;
// //           border-radius: 4px;
// //           cursor: pointer;
// //           font-size: 14px;
// //           font-weight: 500;
// //         }

// //         .close-btn:hover {
// //           background: #545b62;
// //         }

// //         .editor-area {
// //           min-height: ${editorMinHeight} !important;
// //           max-height: ${editorMaxHeight} !important;
// //           overflow-x: hidden;
// //           overflow-y: auto;
// //           padding: 20px;
// //           outline: none;
// //           font-size: 16px;
// //           line-height: 1.6;
// //           color: #212529;
// //           direction: ltr !important;
// //           unicode-bidi: plaintext !important;
// //         }


// //         .editor-area:focus {
// //           outline: 2px solid #1976d2;
// //           outline-offset: -2px;
// //         }

// //         .editor-area h1 {
// //           font-size: 2em;
// //           font-weight: bold;
// //           margin: 0.67em 0;
// //         }

// //         .editor-area h2 {
// //           font-size: 1.5em;
// //           font-weight: bold;
// //           margin: 0.75em 0;
// //         }

// //         .editor-area img {
// //           max-width: 100%;
// //           height: auto;
// //           margin: 10px 0;
// //         }

// //         .editor-area a {
// //           color: #1976d2;
// //           text-decoration: underline;
// //         }
        
// //         .editor-area img {
// //           max-width: 100%;
// //           height: auto;
// //           border: 1px solid transparent;
// //           padding: 2px;
// //         }

// //         /* Show resize handle */
// //         .editor-area img.selected {
// //           outline: 2px solid #1976d2;
// //           position: relative;
// //         }

// //         .editor-area img.selected::after {
// //           content: "";
// //           position: absolute;
// //           bottom: -4px;
// //           right: -4px;
// //           width: 12px;
// //           height: 12px;
// //           background: #1976d2;
// //           cursor: nwse-resize;
// //           border-radius: 2px;
// //         }

         
// //         .editor-area ul,
// //         .editor-area ol {
// //           list-style-position: inside;   /* bullet move with text */
// //           padding-left: 0;
// //         }
// //         .editor-area li {
// //           text-align: inherit;
// //         }

// //         @media (max-width: 768px) {
// //           .editor-container {
// //             margin: 10px;
// //           }

// //           .toolbar {
// //             gap: 2px;
// //             padding: 8px;
// //           }

// //           .toolbar-btn {
// //             width: 32px;
// //             height: 32px;
// //           }

// //           .material-icons {
// //             font-size: 18px;
// //           }

// //   /* View Only / Preview Mode */
// //           .editor-area.view-only {
// //             border: none !important;
// //             outline: none !important;
// //             background: white !important;
// //             padding: 10px 20px; /* cleaner margin */
// //             cursor: default !important;
// //             pointer-events: auto; /* allow text selection */
// //           }

// // /* No resize handles in Preview */
// //           .editor-area.view-only img {
// //             outline: none !important;
// //             cursor: default !important;
// //           }

// //           .editor-area.view-only img::after {
// //             display: none !important;
// //           }

// // /* Remove Scroll bar look */
// //           .editor-area.view-only::-webkit-scrollbar {
// //             width: 6px;
// //           }

// //           .editor-area.view-only::-webkit-scrollbar-thumb {
// //             background: transparent;
// //           }

// // /* For Placeholder */
// //           .editor-area.show-placeholder::before {
// //             content: attr(data-placeholder);
// //             color: #999;
// //             font-style: italic;
// //             pointer-events: none;
// //             position: absolute;
// //           }

// //           .editor-area {
// //             position: relative;
// //           }

// //         }
// //       `}</style>

// //       {showtoolbar && !readOnly && (
// //         <div className="toolbar">
// //           <div className="toolbar-group">
// //             <button
// //               className="toolbar-btn"
// //               onClick={handleUndo}
// //               title="Undo (Ctrl+Z)"
// //             >
// //               <span className="material-icons">undo</span>
// //             </button>
// //             <button
// //               className="toolbar-btn"
// //               onClick={handleRedo}
// //               title="Redo (Ctrl+Y)"
// //             >
// //               <span className="material-icons">redo</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className={`toolbar-btn ${activeHeadings.h1 ? "active" : ""}`}
// //               onClick={() => formatHeading(1)}
// //               title="Heading 1"
// //             >
// //               <span className="material-icons">looks_one</span>
// //             </button>
// //             <button
// //               className={`toolbar-btn ${activeHeadings.h2 ? "active" : ""}`}
// //               onClick={() => formatHeading(2)}
// //               title="Heading 2"
// //             >
// //               <span className="material-icons">looks_two</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className={`toolbar-btn ${activeFormats.bold ? "active" : ""}`}
// //               onClick={() => executeCommand("bold")}
// //               title="Bold (Ctrl+B)"
// //             >
// //               <span className="material-icons">format_bold</span>
// //             </button>
// //             <button
// //               className={`toolbar-btn ${activeFormats.italic ? "active" : ""}`}
// //               onClick={() => executeCommand("italic")}
// //               title="Italic (Ctrl+I)"
// //             >
// //               <span className="material-icons">format_italic</span>
// //             </button>
// //             <button
// //               className={`toolbar-btn ${
// //                 activeFormats.underline ? "active" : ""
// //               }`}
// //               onClick={() => executeCommand("underline")}
// //               title="Underline (Ctrl+U)"
// //             >
// //               <span className="material-icons">format_underlined</span>
// //             </button>
// //             <button
// //               className={`toolbar-btn ${
// //                 activeFormats.strikeThrough ? "active" : ""
// //               }`}
// //               onClick={() => executeCommand("strikeThrough")}
// //               title="Strikethrough"
// //             >
// //               <span className="material-icons">strikethrough_s</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className={`toolbar-btn ${
// //                 activeFormats.superscript ? "active" : ""
// //               }`}
// //               onClick={() => executeCommand("superscript")}
// //               title="Superscript"
// //             >
// //               <span className="material-icons">superscript</span>
// //             </button>
// //             <button
// //               className={`toolbar-btn ${
// //                 activeFormats.subscript ? "active" : ""
// //               }`}
// //               onClick={() => executeCommand("subscript")}
// //               title="Subscript"
// //             >
// //               <span className="material-icons">subscript</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className={`toolbar-btn ${
// //                 activeFormats.insertUnorderedList ? "active" : ""
// //               }`}
// //               onClick={(e) => {
// //                 e.preventDefault();
// //                 executeCommand("insertUnorderedList");
// //               }}
// //               title="Unordered List"
// //             >
// //               <span className="material-icons">format_list_bulleted</span>
// //             </button>
// //             <button
// //               className={`toolbar-btn ${
// //                 activeFormats.insertOrderedList ? "active" : ""
// //               }`}
// //               onClick={(e) => {
// //                 e.preventDefault();
// //                 executeCommand("insertOrderedList");
// //               }}
// //               title="Ordered List"
// //             >
// //               <span className="material-icons">format_list_numbered</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className="toolbar-btn"
// //               onClick={() => executeCommand("justifyLeft")}
// //               title="Align Left"
// //             >
// //               <span className="material-icons">format_align_left</span>
// //             </button>
// //             <button
// //               className="toolbar-btn"
// //               onClick={() => executeCommand("justifyCenter")}
// //               title="Align Center"
// //             >
// //               <span className="material-icons">format_align_center</span>
// //             </button>
// //             <button
// //               className="toolbar-btn"
// //               onClick={() => executeCommand("justifyRight")}
// //               title="Align Right"
// //             >
// //               <span className="material-icons">format_align_right</span>
// //             </button>
// //             <button
// //               className="toolbar-btn"
// //               onClick={() => executeCommand("justifyFull")}
// //               title="Justify"
// //             >
// //               <span className="material-icons">format_align_justify</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className="toolbar-btn"
// //               onClick={(e) => {
// //                 e.preventDefault();
// //                 insertLink();
// //               }}
// //               title="Insert Link"
// //             >
// //               <span className="material-icons">link</span>
// //             </button>
// //             <button
// //               className="toolbar-btn"
// //               onClick={(e) => {
// //                 e.preventDefault();
// //                 insertImage();
// //               }}
// //               title="Insert Image"
// //             >
// //               <span className="material-icons">image</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className="toolbar-btn"
// //               onClick={(e) => {
// //                 e.preventDefault();
// //                 executeCommand("removeFormat");
// //               }}
// //               title="Clear Formatting"
// //             >
// //               <span className="material-icons">format_clear</span>
// //             </button>
// //           </div>

// //           <div className="toolbar-group">
// //             <button
// //               className="toolbar-btn"
// //               onClick={() => setShowFindBar(!showFindBar)}
// //               title="Find (Ctrl+F)"
// //             >
// //               <span className="material-icons">search</span>
// //             </button>
// //             <button
// //               className="toolbar-btn"
// //               onClick={handleCopy}
// //               title="Copy (Ctrl+C)"
// //             >
// //               <span className="material-icons">content_copy</span>
// //             </button>
// //             <button
// //               className="toolbar-btn"
// //               onClick={handlePaste}
// //               title="Paste (Ctrl+V)"
// //             >
// //               <span className="material-icons">content_paste</span>
// //             </button>
// //           </div>
// //         </div>
// //       )}

// //       {showFindBar && (
// //         <div className="find-bar">
// //           <input
// //             type="text"
// //             className="find-input"
// //             placeholder="Find text..."
// //             value={findText}
// //             onChange={(e) => setFindText(e.target.value)}
// //             onKeyPress={(e) => e.key === "Enter" && handleFind()}
// //           />
// //           <button className="find-btn" onClick={handleFind}>
// //             Find
// //           </button>
// //           <button className="close-btn" onClick={() => setShowFindBar(false)}>
// //             Close
// //           </button>
// //         </div>
// //       )}

// //       <div
// //         ref={editor}
// //         className={`editor-area ${readOnly ? "view-only" : ""}`}
// //         contentEditable={!readOnly}
// //         suppressContentEditableWarning
// //         onInput={!readOnly ? onChange : undefined}
// //       />

// //       {isEditorOnly && (
// //         <div
// //           className="d-flex changeBG borderTop"
// //           style={{
// //             justifyContent: mobileView ? "center" : "space-between",
// //             flexWrap: "wrap",
// //             alignItems: "center",
// //             gap: "5px",
// //             boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.3), 0 0 0 white",
// //             padding: "5px",
// //             borderRadius: "0px 0px 8px 8px",
// //             minHeight: "50px",
// //           }}
// //         >
// //           <div className="px-2" style={{ display: mobileView ? "none" : "" }}>
// //             <h6
// //               style={{
// //                 color: "#1976D2",
// //                 fontSize: "13px",
// //                 display: "flex",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <FiberManualRecordIcon fontSize="small" />
// //               <b className="whiteHeading" style={{ marginLeft: "5px" }}>
// //                 {" "}
// //                 {totalWords} | 2500 words{" "}
// //               </b>
// //             </h6>
// //           </div>

// //           <div
// //           // style={{position:"relative", right:"9%"}}
// //           >
// //             <Button
// //               disabled={!accessToParaphrase}
// //               className="OutlinedDarkBtn2"
// //               style={{
// //                 cursor: accessToParaphrase ? "pointer" : "not-allowed",
// //                 fontSize: "12px",
// //                 marginRight: "10px",
// //                 borderRadius: "10px",
// //                 textTransform: "capitalize",
// //                 boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
// //               }}
// //               onClick={handleParaphraseClick}
// //             >
// //               <img
// //                 src={!accessToParaphrase ? paraphrase_Gray : paraphrase_logo}
// //                 alt="Paraphrase"
// //                 style={{ width: "21px", marginRight: "5px" }}
// //               />
// //               Paraphrase
// //             </Button>
// //             <Button
// //               disabled={!accessToSummarize}
// //               className="OutlinedDarkBtn2"
// //               style={{
// //                 cursor: accessToSummarize ? "pointer" : "not-allowed",
// //                 fontSize: "12px",
// //                 marginRight: "10px",
// //                 borderRadius: "10px",
// //                 textTransform: "capitalize",
// //                 boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
// //               }}
// //               onClick={handleSummariserClick}
// //             >
// //               <FaBookOpen
// //                 style={{
// //                   marginRight: "5px",
// //                   width: "18px",
// //                   height: "18px",
// //                 }}
// //               />
// //               Summarize
// //             </Button>
// //             <Button
// //               disabled={!accessToOCR}
// //               onClick={() => ocrCheck()}
// //               className="OutlinedDarkBtn2"
// //               style={{
// //                 textTransform: "capitalize",
// //                 fontSize: mobileView ? "10px" : "12px",
// //                 borderRadius: "10px",
// //                 boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
// //               }}
// //             >
// //               OCR
// //             </Button>
// //             {!isGrammarCheck && (
// //               <Button
// //                 className="OutlinedDarkBtn2"
// //                 style={{
// //                   cursor: "pointer",
// //                   marginLeft: "10px",
// //                   fontSize: "12px",
// //                   // marginRight: "10px",
// //                   borderRadius: "10px",
// //                   textTransform: "capitalize",
// //                   boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
// //                 }}
// //                 onClick={grammarCheckClick}
// //               >
// //                 <Spellcheck />
// //                 Grammar Check
// //               </Button>
// //             )}
// //           </div>
// //           <div
// //             className="buttons-div"
// //             style={{
// //               width: mobileView ? "100%" : "",
// //               display: "flex",
// //               justifyContent: "space-between",
// //               alignItems: "center",
// //             }}
// //           >
// //             <div
// //               className="px-2"
// //               style={{ display: !mobileView ? "none" : "" }}
// //             >
// //               <h6 style={{ color: "#1976D2", fontSize: "10px" }}>
// //                 <FiberManualRecordIcon fontSize="small" />
// //                 <b className="whiteHeading"> {totalWords} words </b>
// //               </h6>
// //             </div>

// //             <div>
// //               <CustomTooltip title="Delete">
// //                 <IconButton
// //                   disabled={!accessToDelete}
// //                   title={"Delete"}
// //                   style={{
// //                     fontSize: "8px",
// //                     marginLeft: "2px",
// //                     color: accessToDelete ? "red" : "#FF6B6B",
// //                     borderColor: "white",
// //                     width: mobileView ? "1px" : "",
// //                   }}
// //                   onClick={handleDeleteFormain}
// //                 >
// //                   <Delete />
// //                 </IconButton>
// //               </CustomTooltip>
// //               <CustomTooltip title="Upload and can also drag and drop document here">
// //                 <IconButton
// //                   className="uploadcolor"
// //                   disabled={!accessToUpload}
// //                   title={"Upload"}
// //                   style={{
// //                     fontSize: "8px",
// //                     marginLeft: "2px",
// //                     borderColor: "white",
// //                     width: mobileView ? "1px" : "",
// //                   }}
// //                   component="label"
// //                   htmlFor="coAutherFileInput"
// //                   onClick={() => handleFileChange()}
// //                 >
// //                   <UploadIcon />
// //                 </IconButton>
// //               </CustomTooltip>
// //               {docId && (
// //                 <CustomTooltip title="Download">
// //                   <IconButton
// //                     title={"Download"}
// //                     style={{
// //                       fontSize: "8px",
// //                       marginLeft: "2px",
// //                       color: "green",
// //                       borderColor: "white",
// //                       width: mobileView ? "1px" : "",
// //                     }}
// //                     onClick={() => {
// //                       openDownloadModal();
// //                     }}
// //                   >
// //                     <DownloadIcon />
// //                   </IconButton>
// //                 </CustomTooltip>
// //               )}
// //               <CustomTooltip title="Copy">
// //                 <IconButton
// //                   title={"Copy"}
// //                   style={{
// //                     fontSize: "8px",
// //                     marginLeft: "2px",
// //                     color: "blue",
// //                     borderColor: "white",
// //                     width: mobileView ? "1px" : "",
// //                   }}
// //                   onClick={handleCopyFormain}
// //                 >
// //                   <ContentCopyIcon />
// //                 </IconButton>
// //               </CustomTooltip>

// //               <CustomTooltip title="Translate">
// //                 <IconButton
// //                   className="translateColor"
// //                   disabled={!accessToTranslate}
// //                   title="Translate"
// //                   style={{
// //                     fontSize: "8px",
// //                     marginLeft: "2px",
// //                     borderColor: "white",
// //                     width: mobileView ? "1px" : "",
// //                   }}
// //                   onClick={handleTranslateClick}
// //                 >
// //                   <TranslateIcon />
// //                 </IconButton>
// //               </CustomTooltip>

// //               <CustomTooltip title="Mic">
// //                 <IconButton
// //                   title={"Mic"}
// //                   style={{
// //                     fontSize: "8px",
// //                     marginLeft: "2px",
// //                     color: isRecording ? "red" : "#FF6B6B",
// //                     borderColor: "white",
// //                     width: mobileView ? "1px" : "",
// //                   }}
// //                   onClick={handleMicClick}
// //                 >
// //                   <MicIcon />
// //                 </IconButton>
// //               </CustomTooltip>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }


// import React, { useState, useRef, useEffect } from "react";
// import Grid from "@mui/material/Unstable_Grid2";
// import {
//   Box,
//   Card,
//   CardContent,
//   Tooltip,
//   IconButton,
//   Button,
//   Divider,
//   Typography,
//   TextField,
//   Chip,
//   Collapse,
// } from "@mui/material";
// import { styled, alpha } from "@mui/material/styles";

// // MUI Icons
// import UndoIcon from "@mui/icons-material/Undo";
// import RedoIcon from "@mui/icons-material/Redo";
// import FormatBoldIcon from "@mui/icons-material/FormatBold";
// import FormatItalicIcon from "@mui/icons-material/FormatItalic";
// import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
// import StrikethroughSIcon from "@mui/icons-material/StrikethroughS";
// import SuperscriptIcon from "@mui/icons-material/Superscript";
// import SubscriptIcon from "@mui/icons-material/Subscript";
// import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
// import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
// import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
// import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
// import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
// import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
// import LinkIcon from "@mui/icons-material/Link";
// import ImageIcon from "@mui/icons-material/Image";
// import FormatClearIcon from "@mui/icons-material/FormatClear";
// import SearchIcon from "@mui/icons-material/Search";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import ContentPasteIcon from "@mui/icons-material/ContentPaste";
// import LooksOneIcon from "@mui/icons-material/LooksOne";
// import LooksTwoIcon from "@mui/icons-material/LooksTwo";
// import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// import { Spellcheck, Delete } from "@mui/icons-material";
// import UploadIcon from "@mui/icons-material/Upload";
// import DownloadIcon from "@mui/icons-material/Download";
// import TranslateIcon from "@mui/icons-material/Translate";
// import MicIcon from "@mui/icons-material/Mic";
// import CloseIcon from "@mui/icons-material/Close";
// import AutoStoriesIcon from "@mui/icons-material/AutoStories";
// import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
// import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";

// // ─── Soft Palette ────────────────────────────────────────────────────────────
// const palette = {
//   primary: "#5B8DEF",
//   primaryLight: "#EBF1FD",
//   primaryMid: "#C5D8FB",
//   secondary: "#7C6FD8",
//   secondaryLight: "#EDEBFB",
//   surface: "#F7F9FF",
//   border: "#DDE3F0",
//   text: "#2D3A56",
//   textMuted: "#7A869A",
//   danger: "#EF5B5B",
//   dangerLight: "#FDEAEA",
//   success: "#45B26B",
//   successLight: "#E8F7EE",
//   white: "#FFFFFF",
//   toolbar: "#F0F4FF",
// };

// // ─── Styled Components ────────────────────────────────────────────────────────

// const StyledCard = styled(Card)({
//   borderRadius: "16px",
//   boxShadow: "0 4px 24px rgba(91,141,239,0.10), 0 1px 4px rgba(0,0,0,0.04)",
//   border: `1px solid ${palette.border}`,
//   overflow: "hidden",
//   background: palette.white,
// });

// const ToolbarBtn = styled(IconButton)(({ active }) => ({
//   width: 34,
//   height: 34,
//   borderRadius: "8px",
//   border: `1px solid ${active ? palette.primary : "transparent"}`,
//   background: active ? palette.primaryLight : "transparent",
//   color: active ? palette.primary : palette.textMuted,
//   transition: "all 0.15s ease",
//   "&:hover": {
//     background: palette.primaryLight,
//     color: palette.primary,
//     border: `1px solid ${palette.primaryMid}`,
//     transform: "translateY(-1px)",
//     boxShadow: "0 2px 8px rgba(91,141,239,0.15)",
//   },
//   "& .MuiSvgIcon-root": {
//     fontSize: 18,
//   },
// }));

// const ToolbarDivider = styled(Divider)({
//   height: 24,
//   borderColor: palette.border,
//   margin: "0 4px",
//   alignSelf: "center",
// });

// const ActionButton = styled(Button)(({ colorvariant }) => {
//   const variants = {
//     primary: {
//       bg: palette.primaryLight,
//       color: palette.primary,
//       border: palette.primaryMid,
//       hoverBg: palette.primaryMid,
//     },
//     purple: {
//       bg: palette.secondaryLight,
//       color: palette.secondary,
//       border: "#C5BFF5",
//       hoverBg: "#D8D4F9",
//     },
//     success: {
//       bg: palette.successLight,
//       color: palette.success,
//       border: "#B3E0C6",
//       hoverBg: "#C8EDD8",
//     },
//     neutral: {
//       bg: "#F4F5F8",
//       color: palette.textMuted,
//       border: palette.border,
//       hoverBg: "#E8EAEF",
//     },
//   };
//   const v = variants[colorvariant] || variants.primary;
//   return {
//     borderRadius: "10px",
//     textTransform: "none",
//     fontSize: "12px",
//     fontWeight: 600,
//     padding: "5px 14px",
//     gap: "6px",
//     border: `1px solid ${v.border}`,
//     background: v.bg,
//     color: v.color,
//     boxShadow: "none",
//     transition: "all 0.15s ease",
//     "&:hover": {
//       background: v.hoverBg,
//       boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//       transform: "translateY(-1px)",
//     },
//     "&.Mui-disabled": {
//       opacity: 0.45,
//       transform: "none",
//     },
//   };
// });

// const StatusIconButton = styled(IconButton)(({ iconcolor }) => ({
//   width: 36,
//   height: 36,
//   borderRadius: "10px",
//   color: iconcolor || palette.textMuted,
//   border: `1px solid transparent`,
//   transition: "all 0.15s ease",
//   "&:hover": {
//     background: alpha(iconcolor || palette.primary, 0.08),
//     border: `1px solid ${alpha(iconcolor || palette.primary, 0.2)}`,
//     transform: "translateY(-1px)",
//   },
//   "&.Mui-disabled": {
//     opacity: 0.35,
//   },
// }));

// const EditorArea = styled(Box)(({ readonly, minheight, maxheight }) => ({
//   minHeight: minheight || "480px",
//   maxHeight: maxheight || "465px",
//   overflowX: "hidden",
//   overflowY: "auto",
//   padding: "24px 28px",
//   outline: "none",
//   fontSize: "15px",
//   lineHeight: 1.7,
//   color: palette.text,
//   fontFamily: "'Georgia', serif",
//   direction: "ltr",
//   unicodeBidi: "plaintext",
//   background: palette.white,
//   caretColor: palette.primary,
//   cursor: readonly ? "default" : "text",
//   "&:focus": {
//     outline: "none",
//   },
//   "& h1": {
//     fontSize: "2em",
//     fontWeight: 700,
//     margin: "0.5em 0",
//     color: palette.text,
//   },
//   "& h2": {
//     fontSize: "1.5em",
//     fontWeight: 600,
//     margin: "0.5em 0",
//     color: palette.text,
//   },
//   "& a": {
//     color: palette.primary,
//     textDecoration: "underline",
//   },
//   "& img": {
//     maxWidth: "100%",
//     height: "auto",
//     margin: "10px 0",
//     borderRadius: "8px",
//     border: `1px solid ${palette.border}`,
//   },
//   "& img.selected": {
//     outline: `2px solid ${palette.primary}`,
//   },
//   "& ul, & ol": {
//     listStylePosition: "inside",
//     paddingLeft: 0,
//   },
//   "&::before": {
//     content: "attr(data-placeholder)",
//     color: palette.textMuted,
//     fontStyle: "italic",
//     pointerEvents: "none",
//     position: "absolute",
//     opacity: 0,
//   },
//   scrollbarWidth: "thin",
//   scrollbarColor: `${palette.border} transparent`,
//   "&::-webkit-scrollbar": { width: "6px" },
//   "&::-webkit-scrollbar-thumb": {
//     background: palette.border,
//     borderRadius: "3px",
//   },
// }));

// // ─── Main Component ───────────────────────────────────────────────────────────

// export default function RichTextEditor({
//   editor,
//   editorContent,
//   showtoolbar,
//   onChange,
//   readOnly,
//   minHeight,
//   maxHeight,
//   editorId,
//   placeholder,
//   isGrammarCheck,
//   mobileView,
//   totalWords,
//   accessToParaphrase,
//   handleParaphraseClick,
//   accessToSummarize,
//   handleSummariserClick,
//   accessToOCR,
//   accessToDelete,
//   handleDeleteFormain,
//   accessToUpload,
//   handleFileChange,
//   docId,
//   handleCopyFormain,
//   accessToTranslate,
//   handleTranslateClick,
//   isRecording,
//   handleMicClick,
//   ocrCheck,
//   grammarCheckClick,
//   openDownloadModal,
//   isEditorOnly = false,
// }) {
//   const [findText, setFindText] = useState("");
//   const [showFindBar, setShowFindBar] = useState(false);
//   const [activeFormats, setActiveFormats] = useState({});
//   const [activeHeadings, setActiveHeadings] = useState({ h1: false, h2: false });

//   const toCssSize = (value, fallback) =>
//     typeof value === "number" ? `${value}px` : value || fallback;
//   const editorMinHeight = toCssSize(minHeight, "480px");
//   const editorMaxHeight = toCssSize(maxHeight, "465px");

//   const executeCommand = (command, value = null) => {
//     editor.current.focus();
//     document.execCommand(command, false, value);
//     updateActiveFormats();
//   };

//   useEffect(() => {
//     if (readOnly) return;
//     const el = editor.current;
//     if (!el) return;
//     el.addEventListener("click", (e) => {
//       if (e.target.tagName === "IMG") {
//         el.querySelectorAll("img").forEach((img) => img.classList.remove("selected"));
//         e.target.classList.add("selected");
//         enableResize(e.target);
//       }
//     });
//   }, [readOnly]);

//   const enableResize = (img) => {
//     let isResizing = false;
//     let startX, startWidth;
//     img.addEventListener("mousedown", (e) => {
//       const rect = img.getBoundingClientRect();
//       if (e.clientX > rect.right - 10 && e.clientY > rect.bottom - 10) {
//         isResizing = true;
//         startX = e.clientX;
//         startWidth = rect.width;
//         e.preventDefault();
//       }
//     });
//     document.addEventListener("mousemove", (e) => {
//       if (!isResizing) return;
//       img.style.width = startWidth + (e.clientX - startX) + "px";
//       img.style.height = "auto";
//     });
//     document.addEventListener("mouseup", () => { isResizing = false; });
//   };

//   const updateActiveFormats = () => {
//     setActiveFormats({
//       bold: document.queryCommandState("bold"),
//       italic: document.queryCommandState("italic"),
//       underline: document.queryCommandState("underline"),
//       strikeThrough: document.queryCommandState("strikeThrough"),
//       superscript: document.queryCommandState("superscript"),
//       subscript: document.queryCommandState("subscript"),
//       insertUnorderedList: document.queryCommandState("insertUnorderedList"),
//       insertOrderedList: document.queryCommandState("insertOrderedList"),
//     });
//   };

//   const insertLink = () => {
//     const selection = window.getSelection();
//     if (selection.rangeCount === 0) { alert("Please select some text first"); return; }
//     const url = prompt("Enter URL:", "https://");
//     if (url && url.trim() !== "" && url !== "https://") executeCommand("createLink", url);
//   };

//   const insertImage = () => {
//     const fileInput = document.createElement("input");
//     fileInput.type = "file";
//     fileInput.accept = "image/*";
//     fileInput.style.display = "none";
//     fileInput.onchange = (e) => {
//       const file = e.target.files[0];
//       if (!file) return;
//       const reader = new FileReader();
//       reader.onload = (ev) => {
//         editor.current.focus();
//         document.execCommand("insertImage", false, ev.target.result);
//       };
//       reader.readAsDataURL(file);
//     };
//     document.body.appendChild(fileInput);
//     fileInput.click();
//     document.body.removeChild(fileInput);
//   };

//   const formatHeading = (level) => {
//     const key = `h${level}`;
//     if (activeHeadings[key]) {
//       executeCommand("fontSize", "3");
//       executeCommand("bold");
//       setActiveHeadings({ ...activeHeadings, [key]: false });
//     } else {
//       executeCommand("fontSize", level === 1 ? "7" : "6");
//       executeCommand("bold");
//       setActiveHeadings({ ...activeHeadings, [key]: true });
//     }
//   };

//   const handleFind = () => { if (findText) window.find(findText); };
//   const handleCopy = () => document.execCommand("copy");
//   const handlePaste = async () => {
//     try {
//       const text = await navigator.clipboard.readText();
//       executeCommand("insertText", text);
//     } catch (err) {
//       console.error("Failed to paste:", err);
//     }
//   };

//   // ─── Toolbar Groups ─────────────────────────────────────────────────────────
//   const toolbarGroups = [
//     // History
//     [
//       { icon: <UndoIcon />, action: () => executeCommand("undo"), title: "Undo (Ctrl+Z)" },
//       { icon: <RedoIcon />, action: () => executeCommand("redo"), title: "Redo (Ctrl+Y)" },
//     ],
//     // Headings
//     [
//       { icon: <LooksOneIcon />, action: () => formatHeading(1), title: "Heading 1", activeKey: "h1_heading" },
//       { icon: <LooksTwoIcon />, action: () => formatHeading(2), title: "Heading 2", activeKey: "h2_heading" },
//     ],
//     // Inline format
//     [
//       { icon: <FormatBoldIcon />, action: () => executeCommand("bold"), title: "Bold", activeKey: "bold" },
//       { icon: <FormatItalicIcon />, action: () => executeCommand("italic"), title: "Italic", activeKey: "italic" },
//       { icon: <FormatUnderlinedIcon />, action: () => executeCommand("underline"), title: "Underline", activeKey: "underline" },
//       { icon: <StrikethroughSIcon />, action: () => executeCommand("strikeThrough"), title: "Strikethrough", activeKey: "strikeThrough" },
//     ],
//     // Script
//     [
//       { icon: <SuperscriptIcon />, action: () => executeCommand("superscript"), title: "Superscript", activeKey: "superscript" },
//       { icon: <SubscriptIcon />, action: () => executeCommand("subscript"), title: "Subscript", activeKey: "subscript" },
//     ],
//     // Lists
//     [
//       { icon: <FormatListBulletedIcon />, action: (e) => { e.preventDefault(); executeCommand("insertUnorderedList"); }, title: "Bullet List", activeKey: "insertUnorderedList" },
//       { icon: <FormatListNumberedIcon />, action: (e) => { e.preventDefault(); executeCommand("insertOrderedList"); }, title: "Numbered List", activeKey: "insertOrderedList" },
//     ],
//     // Alignment
//     [
//       { icon: <FormatAlignLeftIcon />, action: () => executeCommand("justifyLeft"), title: "Align Left" },
//       { icon: <FormatAlignCenterIcon />, action: () => executeCommand("justifyCenter"), title: "Align Center" },
//       { icon: <FormatAlignRightIcon />, action: () => executeCommand("justifyRight"), title: "Align Right" },
//       { icon: <FormatAlignJustifyIcon />, action: () => executeCommand("justifyFull"), title: "Justify" },
//     ],
//     // Insert
//     [
//       { icon: <LinkIcon />, action: (e) => { e.preventDefault(); insertLink(); }, title: "Insert Link" },
//       { icon: <ImageIcon />, action: (e) => { e.preventDefault(); insertImage(); }, title: "Insert Image" },
//     ],
//     // Utilities
//     [
//       { icon: <FormatClearIcon />, action: (e) => { e.preventDefault(); executeCommand("removeFormat"); }, title: "Clear Formatting" },
//       { icon: <SearchIcon />, action: () => setShowFindBar(!showFindBar), title: "Find (Ctrl+F)" },
//       { icon: <ContentCopyIcon />, action: handleCopy, title: "Copy" },
//       { icon: <ContentPasteIcon />, action: handlePaste, title: "Paste" },
//     ],
//   ];

//   const isActive = (group_btn) => {
//     if (!group_btn.activeKey) return false;
//     if (group_btn.activeKey === "h1_heading") return activeHeadings.h1;
//     if (group_btn.activeKey === "h2_heading") return activeHeadings.h2;
//     return activeFormats[group_btn.activeKey] || false;
//   };

//   return (
//     <StyledCard>
//       {/* ── Toolbar ─────────────────────────────────────────────────────────── */}
//       {showtoolbar && !readOnly && (
//         <Box
//           sx={{
//             background: palette.toolbar,
//             borderBottom: `1px solid ${palette.border}`,
//             px: 1.5,
//             py: 1,
//           }}
//         >
//           <Grid container alignItems="center" spacing={0} sx={{ flexWrap: "wrap", gap: "4px", rowGap: "6px" }}>
//             {toolbarGroups.map((group, gi) => (
//               <React.Fragment key={gi}>
//                 {gi > 0 && <ToolbarDivider orientation="vertical" flexItem />}
//                 <Grid sx={{ display: "flex", gap: "3px", alignItems: "center" }}>
//                   {group.map((btn, bi) => (
//                     <Tooltip key={bi} title={btn.title} placement="top" arrow
//                       componentsProps={{
//                         tooltip: {
//                           sx: {
//                             bgcolor: palette.text,
//                             fontSize: "11px",
//                             borderRadius: "6px",
//                             "& .MuiTooltip-arrow": { color: palette.text },
//                           },
//                         },
//                       }}
//                     >
//                       <ToolbarBtn active={isActive(btn) ? 1 : 0} onClick={btn.action} size="small">
//                         {btn.icon}
//                       </ToolbarBtn>
//                     </Tooltip>
//                   ))}
//                 </Grid>
//               </React.Fragment>
//             ))}
//           </Grid>
//         </Box>
//       )}

//       {/* ── Find Bar ────────────────────────────────────────────────────────── */}
//       <Collapse in={showFindBar}>
//         <Box
//           sx={{
//             display: "flex",
//             gap: 1,
//             px: 2,
//             py: 1.2,
//             alignItems: "center",
//             background: "#FFFBEB",
//             borderBottom: `1px solid #F0D070`,
//           }}
//         >
//           <SearchIcon sx={{ color: "#B8860B", fontSize: 18 }} />
//           <TextField
//             size="small"
//             placeholder="Find text…"
//             value={findText}
//             onChange={(e) => setFindText(e.target.value)}
//             onKeyPress={(e) => e.key === "Enter" && handleFind()}
//             sx={{
//               flex: 1,
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: "8px",
//                 fontSize: "13px",
//                 background: palette.white,
//                 "& fieldset": { borderColor: "#E8D060" },
//                 "&:hover fieldset": { borderColor: "#C8A020" },
//                 "&.Mui-focused fieldset": { borderColor: "#C8A020" },
//               },
//             }}
//           />
//           <Button
//             size="small"
//             onClick={handleFind}
//             sx={{
//               borderRadius: "8px",
//               textTransform: "none",
//               fontWeight: 600,
//               background: "#F0C040",
//               color: "#5A3800",
//               fontSize: "12px",
//               "&:hover": { background: "#E0B030" },
//             }}
//           >
//             Find
//           </Button>
//           <IconButton size="small" onClick={() => setShowFindBar(false)}
//             sx={{ color: palette.textMuted, "&:hover": { color: palette.danger } }}>
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </Collapse>

//       {/* ── Editor Area ──────────────────────────────────────────────────────── */}
//       <Box sx={{ position: "relative" }}>
//         <EditorArea
//           ref={editor}
//           component="div"
//           readonly={readOnly}
//           minheight={editorMinHeight}
//           maxheight={editorMaxHeight}
//           contentEditable={!readOnly}
//           suppressContentEditableWarning
//           onInput={!readOnly ? onChange : undefined}
//           onKeyUp={updateActiveFormats}
//           onMouseUp={updateActiveFormats}
//           data-placeholder={placeholder || "Start typing…"}
//           sx={{
//             "&:empty::before": {
//               content: "attr(data-placeholder)",
//               color: palette.textMuted,
//               fontStyle: "italic",
//               pointerEvents: "none",
//               opacity: 1,
//             },
//           }}
//         />
//       </Box>

//       {/* ── Bottom Action Bar ────────────────────────────────────────────────── */}
//       {isEditorOnly && (
//         <Box
//           sx={{
//             borderTop: `1px solid ${palette.border}`,
//             background: palette.surface,
//             px: 2,
//             py: 1.2,
//             borderRadius: "0 0 16px 16px",
//           }}
//         >
//           <Grid container alignItems="center" justifyContent="space-between" spacing={1} wrap="wrap">

//             {/* ── Word Count ── */}
//             {!mobileView && (
//               <Grid xs="auto">
//                 <Chip
//                   icon={<FiberManualRecordIcon sx={{ fontSize: "10px !important", color: `${palette.success} !important` }} />}
//                   label={
//                     <Typography sx={{ fontSize: "12px", fontWeight: 600, color: palette.text }}>
//                       {totalWords} <Typography component="span" sx={{ fontWeight: 400, color: palette.textMuted, fontSize: "12px" }}>/ 2500 words</Typography>
//                     </Typography>
//                   }
//                   size="small"
//                   sx={{
//                     background: palette.successLight,
//                     border: `1px solid #B3E0C6`,
//                     borderRadius: "8px",
//                     height: "28px",
//                     pl: 0.5,
//                   }}
//                 />
//               </Grid>
//             )}

//             {/* ── AI Action Buttons ── */}
//             <Grid xs="auto">
//               <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
//                 <Tooltip title={!accessToParaphrase ? "Paraphrase not available" : ""}>
//                   <span>
//                     <ActionButton
//                       colorvariant="primary"
//                       disabled={!accessToParaphrase}
//                       onClick={handleParaphraseClick}
//                       startIcon={<AutoFixHighIcon sx={{ fontSize: "16px !important" }} />}
//                     >
//                       Paraphrase
//                     </ActionButton>
//                   </span>
//                 </Tooltip>

//                 <Tooltip title={!accessToSummarize ? "Summarize not available" : ""}>
//                   <span>
//                     <ActionButton
//                       colorvariant="purple"
//                       disabled={!accessToSummarize}
//                       onClick={handleSummariserClick}
//                       startIcon={<AutoStoriesIcon sx={{ fontSize: "16px !important" }} />}
//                     >
//                       Summarize
//                     </ActionButton>
//                   </span>
//                 </Tooltip>

//                 <Tooltip title={!accessToOCR ? "OCR not available" : ""}>
//                   <span>
//                     <ActionButton
//                       colorvariant="success"
//                       disabled={!accessToOCR}
//                       onClick={() => ocrCheck && ocrCheck()}
//                       startIcon={<DocumentScannerIcon sx={{ fontSize: "16px !important" }} />}
//                     >
//                       OCR
//                     </ActionButton>
//                   </span>
//                 </Tooltip>

//                 {!isGrammarCheck && (
//                   <ActionButton
//                     colorvariant="neutral"
//                     onClick={grammarCheckClick}
//                     startIcon={<Spellcheck sx={{ fontSize: "16px !important" }} />}
//                   >
//                     Grammar
//                   </ActionButton>
//                 )}
//               </Box>
//             </Grid>

//             {/* ── Icon Actions ── */}
//             <Grid xs="auto">
//               <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>

//                 {mobileView && (
//                   <Chip
//                     icon={<FiberManualRecordIcon sx={{ fontSize: "10px !important", color: `${palette.success} !important` }} />}
//                     label={<Typography sx={{ fontSize: "11px", fontWeight: 600, color: palette.text }}>{totalWords} words</Typography>}
//                     size="small"
//                     sx={{ background: palette.successLight, border: `1px solid #B3E0C6`, borderRadius: "8px", mr: 0.5 }}
//                   />
//                 )}

//                 <Tooltip title="Delete" arrow>
//                   <span>
//                     <StatusIconButton
//                       iconcolor={palette.danger}
//                       disabled={!accessToDelete}
//                       onClick={handleDeleteFormain}
//                       size="small"
//                     >
//                       <Delete fontSize="small" />
//                     </StatusIconButton>
//                   </span>
//                 </Tooltip>

//                 <Tooltip title="Upload (or drag & drop)" arrow>
//                   <span>
//                     <StatusIconButton
//                       iconcolor={palette.primary}
//                       disabled={!accessToUpload}
//                       component="label"
//                       htmlFor="coAutherFileInput"
//                       onClick={() => handleFileChange && handleFileChange()}
//                       size="small"
//                     >
//                       <UploadIcon fontSize="small" />
//                     </StatusIconButton>
//                   </span>
//                 </Tooltip>

//                 {docId && (
//                   <Tooltip title="Download" arrow>
//                     <StatusIconButton
//                       iconcolor={palette.success}
//                       onClick={openDownloadModal}
//                       size="small"
//                     >
//                       <DownloadIcon fontSize="small" />
//                     </StatusIconButton>
//                   </Tooltip>
//                 )}

//                 <Tooltip title="Copy" arrow>
//                   <StatusIconButton iconcolor={palette.primary} onClick={handleCopyFormain} size="small">
//                     <ContentCopyIcon fontSize="small" />
//                   </StatusIconButton>
//                 </Tooltip>

//                 <Tooltip title="Translate" arrow>
//                   <span>
//                     <StatusIconButton
//                       iconcolor={palette.secondary}
//                       disabled={!accessToTranslate}
//                       onClick={handleTranslateClick}
//                       size="small"
//                     >
//                       <TranslateIcon fontSize="small" />
//                     </StatusIconButton>
//                   </span>
//                 </Tooltip>

//                 <Tooltip title={isRecording ? "Stop recording" : "Start mic"} arrow>
//                   <StatusIconButton
//                     iconcolor={isRecording ? palette.danger : palette.textMuted}
//                     onClick={handleMicClick}
//                     size="small"
//                     sx={{
//                       background: isRecording ? palette.dangerLight : "transparent",
//                       border: isRecording ? `1px solid ${alpha(palette.danger, 0.3)}` : "1px solid transparent",
//                       animation: isRecording ? "pulse 1.2s ease-in-out infinite" : "none",
//                       "@keyframes pulse": {
//                         "0%, 100%": { boxShadow: `0 0 0 0 ${alpha(palette.danger, 0.3)}` },
//                         "50%": { boxShadow: `0 0 0 6px ${alpha(palette.danger, 0)}` },
//                       },
//                     }}
//                   >
//                     <MicIcon fontSize="small" />
//                   </StatusIconButton>
//                 </Tooltip>
//               </Box>
//             </Grid>

//           </Grid>
//         </Box>
//       )}
//     </StyledCard>
//   );
// }

import React, { useState, useEffect, useCallback, useRef } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Tooltip,
  IconButton,
  Button,
  Divider,
  Typography,
  TextField,
  Chip,
  Collapse,
  Paper,
} from "@mui/material";
import { styled, alpha, keyframes } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";

// ── MUI Icons ────────────────────────────────────────────────────────────────
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import StrikethroughSIcon from "@mui/icons-material/StrikethroughS";
import SuperscriptIcon from "@mui/icons-material/Superscript";
import SubscriptIcon from "@mui/icons-material/Subscript";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import LinkIcon from "@mui/icons-material/Link";
import ImageIcon from "@mui/icons-material/Image";
import FormatClearIcon from "@mui/icons-material/FormatClear";
import SearchIcon from "@mui/icons-material/Search";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Spellcheck, Delete } from "@mui/icons-material";
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import TranslateIcon from "@mui/icons-material/Translate";
import MicIcon from "@mui/icons-material/Mic";
import CloseIcon from "@mui/icons-material/Close";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FormatIndentIncreaseIcon from "@mui/icons-material/FormatIndentIncrease";
import FormatIndentDecreaseIcon from "@mui/icons-material/FormatIndentDecrease";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import TuneIcon from "@mui/icons-material/Tune";

// ── Design Tokens ─────────────────────────────────────────────────────────────
const C = {
  surface:      "#FFFFFF",
  surfaceAlt:   "#F8F9FE",
  border:       "rgba(120,140,220,0.18)",
  borderStrong: "rgba(100,120,200,0.28)",
  accent:       "#5B6FE8",
  accentLight:  "#EEF0FD",
  accentMid:    "#C5CCF7",
  accentDark:   "#4455CC",
  teal:         "#4ECDC4",
  tealLight:    "#E8FAF9",
  tealDark:     "#38A89D",
  purple:       "#7C6FD8",
  purpleLight:  "#F0EEFF",
  purpleMid:    "#C5BFF5",
  text:         "#1E2140",
  textSub:      "#4A5280",
  textMuted:    "#8891B8",
  toolbar:      "#F8F9FE",
  danger:       "#EF5B5B",
  dangerLight:  "#FDEAEA",
  success:      "#45B26B",
  successLight: "#E8F7EE",
  warning:      "#F59E0B",
  warningLight: "#FFFBEB",
  warningMid:   "#FDE68A",
};

const R = { sm: "8px", md: "12px", lg: "16px", xl: "20px", full: "100px" };

const SHADOW = {
  card:  "0 8px 40px rgba(91,111,232,0.09), 0 2px 8px rgba(0,0,0,0.04)",
  popup: "0 20px 60px rgba(30,33,64,0.18), 0 4px 16px rgba(0,0,0,0.08)",
  teal:  "0 4px 16px rgba(78,205,196,0.38)",
  btn:   "0 4px 16px rgba(91,111,232,0.30)",
};

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));

// ── Keyframes ─────────────────────────────────────────────────────────────────
const popIn = keyframes`
  from { opacity:0; transform: translate(-50%,-95%) scale(0.93); }
  to   { opacity:1; transform: translate(-50%,-110%) scale(1); }
`;

const pulseAnim = keyframes`
  0%,100% { box-shadow: 0 0 0 0 rgba(239,91,91,0.35); }
  50%      { box-shadow: 0 0 0 7px rgba(239,91,91,0); }
`;

// ── Styled: Editor Card ───────────────────────────────────────────────────────
const EditorCard = styled(Paper)({
  borderRadius: R.xl,
  boxShadow: SHADOW.card,
  border: `1px solid ${C.border}`,
  overflow: "hidden",
  background: C.surface,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
  transition: "box-shadow 0.2s ease",
  "&:hover": {
    boxShadow: "0 12px 48px rgba(91,111,232,0.13), 0 2px 8px rgba(0,0,0,0.05)",
  },
});

// ── Styled: AI Panel Card ─────────────────────────────────────────────────────
const AICard = styled(Paper)({
  borderRadius: R.xl,
  boxShadow: SHADOW.card,
  border: `1px solid ${C.border}`,
  background: C.surface,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
});

// ── Styled: Toolbar Button ────────────────────────────────────────────────────
const TBtn = styled(IconButton, {
  shouldForwardProp: (p) => p !== "$active",
})(({ $active }) => ({
  width: 30,
  height: 30,
  borderRadius: R.sm,
  border: `1px solid ${$active ? C.accent : "transparent"}`,
  background: $active ? C.accentLight : "transparent",
  color: $active ? C.accent : C.textMuted,
  transition: "all 0.14s ease",
  "& .MuiSvgIcon-root": { fontSize: 16 },
  "&:hover": {
    background: C.accentLight,
    color: C.accent,
    border: `1px solid ${C.accentMid}`,
    transform: "translateY(-1px)",
    boxShadow: "0 2px 8px rgba(91,111,232,0.14)",
  },
}));

const TDivider = styled(Divider)({
  height: 20,
  borderColor: C.border,
  margin: "0 3px",
  alignSelf: "center",
});

// ── Styled: AI Action Row ─────────────────────────────────────────────────────
const AIActionRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "9px 12px",
  cursor: "pointer",
  borderRadius: R.md,
  margin: "2px 0",
  transition: "all 0.14s ease",
  "&:hover": {
    background: C.accentLight,
    "& .chevron": { color: C.accent, transform: "translateX(2px)" },
  },
  "& .chevron": {
    transition: "all 0.14s ease",
  },
});

// ── Styled: Mode Button ───────────────────────────────────────────────────────
const ModeBtn = styled(Button, {
  shouldForwardProp: (p) => p !== "$selected",
})(({ $selected }) => ({
  borderRadius: R.full,
  textTransform: "none",
  fontSize: "12px",
  fontWeight: $selected ? 700 : 500,
  padding: "5px 14px",
  border: `1.5px solid ${$selected ? C.accent : C.border}`,
  background: $selected ? C.accentLight : "transparent",
  color: $selected ? C.accent : C.textMuted,
  boxShadow: "none",
  minWidth: 0,
  "&:hover": {
    background: C.accentLight,
    borderColor: C.accent,
    color: C.accent,
    boxShadow: "none",
  },
}));

// ── Styled: Stat Box ──────────────────────────────────────────────────────────
const StatBox = styled(Box)(({ $bg, $color, $border }) => ({
  textAlign: "center",
  padding: "10px 6px",
  borderRadius: R.md,
  background: $bg,
  border: `1px solid ${$border}`,
  flex: 1,
}));

// ── Sub-component: Selection Popup ────────────────────────────────────────────
const SelectionPopup = ({ popup, onClose, onRewrite, onImprove, onTone }) => {
  const [tab, setTab] = useState(0);
  if (!popup.visible) return null;

  const tabs = [
    { label: "Rewrite",  action: onRewrite },
    { label: "Improve",  action: onImprove },
    { label: "Tone",     action: onTone },
  ];

  return (
    <Box
      onMouseDown={(e) => e.preventDefault()}
      sx={{
        position: "fixed",
        top: popup.y,
        left: popup.x,
        transform: "translate(-50%, -112%)",
        zIndex: 9999,
        background: "rgba(255,255,255,0.96)",
        borderRadius: "18px",
        boxShadow: "0 20px 55px rgba(91,111,232,0.18)",
        border: `1px solid ${alpha(C.accent, 0.12)}`,
        minWidth: 300,
        maxWidth: 360,
        overflow: "visible",
        animation: `${popIn} 0.2s ease forwards`,
        backdropFilter: "blur(14px)",
        "&::after": {
          content: '""',
          position: "absolute",
          left: "50%",
          bottom: -7,
          width: 14,
          height: 14,
          background: "rgba(255,255,255,0.96)",
          borderRight: `1px solid ${alpha(C.accent, 0.12)}`,
          borderBottom: `1px solid ${alpha(C.accent, 0.12)}`,
          transform: "translateX(-50%) rotate(45deg)",
        },
      }}
    >
      {/* Tab Row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: `1px solid ${alpha(C.accent, 0.08)}`,
          px: 1.4,
          py: 0.45,
          background: "transparent",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 700,
            color: C.textMuted,
            mr: 0.75,
          }}
        >
          Suggestion:
        </Typography>
        {tabs.map((t, i) => (
          <Button
            key={t.label}
            onClick={() => setTab(i)}
            disableRipple
            sx={{
              px: 1.1,
              py: 0.8,
              fontSize: "12px",
              fontWeight: tab === i ? 700 : 500,
              color: tab === i ? C.accent : C.textMuted,
              borderBottom: `2px solid ${tab === i ? C.accent : "transparent"}`,
              borderRadius: 0,
              textTransform: "none",
              minWidth: "auto",
              transition: "all 0.14s",
            }}
          >
            {t.label}
          </Button>
        ))}
        <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            sx={{ display: "none" }}
          >
            <MoreHorizIcon sx={{ fontSize: 17 }} />
          </IconButton>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: C.textMuted,
              width: 28,
              height: 28,
              "&:hover": { color: C.danger, background: C.dangerLight },
            }}
          >
            <CloseIcon sx={{ fontSize: 15 }} />
          </IconButton>
        </Box>
      </Box>

      {/* Content Preview */}
      <Box
        sx={{
          mx: 1.5,
          mt: 0.35,
          mb: 0.9,
          px: 1.2,
          py: 1,
          fontSize: "13px",
          color: C.text,
          lineHeight: 1.45,
          maxHeight: 88,
          overflow: "auto",
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          borderRadius: R.md,
          background: C.surfaceAlt,
          border: `1px solid ${C.border}`,
        }}
      >
        {popup.text
          ? popup.text.length > 160
            ? popup.text.substring(0, 160) + "…"
            : popup.text
          : "Select text to proceed…"}
      </Box>

      {/* Action Row */}
      <Box sx={{ px: 1.5, pb: 1.4, pt: 0.15, display: "flex", gap: 0.75 }}>
        <Button
          onClick={() => { tabs[tab].action?.(); onClose(); }}
          fullWidth
          sx={{
            borderRadius: "12px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "12.5px",
            py: 0.72,
            background: `linear-gradient(135deg, ${C.accent} 0%, ${C.accentDark} 100%)`,
            color: "#fff",
            boxShadow: "0 10px 22px rgba(91,111,232,0.22)",
            border: "none",
            "&:hover": {
              background: `linear-gradient(135deg, ${C.accentDark} 0%, #3148b8 100%)`,
              boxShadow: "0 8px 20px rgba(91,111,232,0.28)",
              transform: "translateY(-1px)",
            },
            transition: "all 0.15s ease",
          }}
        >
          {tabs[tab].label}
        </Button>
        <IconButton
          sx={{
            width: 36,
            height: 36,
            borderRadius: "12px",
            border: `1px solid ${C.border}`,
            color: C.textMuted,
            flexShrink: 0,
            "&:hover": {
              borderColor: C.accentMid,
              color: C.accentDark,
              background: C.accentLight,
            },
          }}
        >
          <AddIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════
export default function RichTextEditor({
  editor,
  editorContent,
  showtoolbar,
  onChange,
  readOnly,
  minHeight,
  maxHeight,
  editorId,
  placeholder,
  isGrammarCheck,
  mobileView,
  totalWords,
  accessToParaphrase,
  handleParaphraseClick,
  accessToSummarize,
  handleSummariserClick,
  accessToOCR,
  accessToDelete,
  handleDeleteFormain,
  accessToUpload,
  handleFileChange,
  docId,
  handleCopyFormain,
  accessToTranslate,
  handleTranslateClick,
  isRecording,
  handleMicClick,
  ocrCheck,
  grammarCheckClick,
  openDownloadModal,
  isEditorOnly = false,
}) {
  // ── State ──────────────────────────────────────────────────────────────────
  const [findText, setFindText]         = useState("");
  const [showFindBar, setShowFindBar]   = useState(false);
  const [activeFormats, setActiveFormats] = useState({});
  const [activeHeadings, setActiveHeadings] = useState({ h1: false, h2: false });
  const [selPopup, setSelPopup]         = useState({ visible: false, x: 0, y: 0, text: "" });
  const [writingMode, setWritingMode]   = useState("balanced");
  const [chapters, setChapters]         = useState([]);
  const [chaptersOpen, setChaptersOpen] = useState(true);
  const [showAIPanel, setShowAIPanel]   = useState(true);
  const [activeChapter, setActiveChapter] = useState(0);
  const selectionPopupTimerRef = useRef(null);

  // ── Derived ────────────────────────────────────────────────────────────────
  const rawText    = editorContent ? editorContent.replace(/<[^>]*>/g, "") : "";
  const charCount  = rawText.length;
  const readTime   = Math.max(1, Math.round((totalWords || 0) / 200));

  const toCss = (v, fb) => (typeof v === "number" ? `${v}px` : v || fb);
  const editorMinH = toCss(minHeight, "400px");
  const editorMaxH = toCss(maxHeight, "500px");

  // ── Extract chapters from headings ─────────────────────────────────────────
  useEffect(() => {
    if (!editorContent) { setChapters([]); return; }
    const div = document.createElement("div");
    div.innerHTML = editorContent;
    const hs = Array.from(div.querySelectorAll("h1, h2, h3"));
    setChapters(
      hs.map((h, i) => ({ id: i, title: h.textContent || `Section ${i + 1}`, level: parseInt(h.tagName[1]) }))
    );
  }, [editorContent]);

  // ── Editor commands ────────────────────────────────────────────────────────
  const exec = useCallback((cmd, value = null) => {
    editor?.current?.focus();
    document.execCommand(cmd, false, value);
    updateFormats();
  }, [editor]);

  const updateFormats = () => {
    setActiveFormats({
      bold:               document.queryCommandState("bold"),
      italic:             document.queryCommandState("italic"),
      underline:          document.queryCommandState("underline"),
      strikeThrough:      document.queryCommandState("strikeThrough"),
      superscript:        document.queryCommandState("superscript"),
      subscript:          document.queryCommandState("subscript"),
      insertUnorderedList: document.queryCommandState("insertUnorderedList"),
      insertOrderedList:  document.queryCommandState("insertOrderedList"),
    });
  };

  const formatH = (level) => {
    const key = `h${level}`;
    if (activeHeadings[key]) {
      exec("fontSize", "3");
      setActiveHeadings({ ...activeHeadings, [key]: false });
    } else {
      exec("fontSize", level === 1 ? "7" : "6");
      exec("bold");
      setActiveHeadings({ ...activeHeadings, [key]: true });
    }
  };

  const insertLink = () => {
    const sel = window.getSelection();
    if (!sel?.rangeCount) { alert("Please select text first"); return; }
    const url = prompt("Enter URL:", "https://");
    if (url && url !== "https://") exec("createLink", url);
  };

  const insertImage = () => {
    const inp = document.createElement("input");
    inp.type = "file"; inp.accept = "image/*"; inp.style.display = "none";
    inp.onchange = (e) => {
      const f = e.target.files[0];
      if (!f) return;
      const r = new FileReader();
      r.onload = (ev) => { editor?.current?.focus(); document.execCommand("insertImage", false, ev.target.result); };
      r.readAsDataURL(f);
    };
    document.body.appendChild(inp);
    inp.click();
    document.body.removeChild(inp);
  };

  // ── Image resize ───────────────────────────────────────────────────────────
  useEffect(() => {
    if (readOnly || !editor?.current) return;
    const el = editor.current;
    const onClick = (e) => {
      if (e.target.tagName === "IMG") {
        el.querySelectorAll("img").forEach((i) => i.classList.remove("selected"));
        e.target.classList.add("selected");
        enableResize(e.target);
      }
    };
    el.addEventListener("click", onClick);
    return () => el.removeEventListener("click", onClick);
  }, [readOnly]);

  const enableResize = (img) => {
    let resizing = false, startX, startW;
    img.addEventListener("mousedown", (e) => {
      const rect = img.getBoundingClientRect();
      if (e.clientX > rect.right - 10 && e.clientY > rect.bottom - 10) {
        resizing = true; startX = e.clientX; startW = rect.width; e.preventDefault();
      }
    });
    document.addEventListener("mousemove", (e) => {
      if (!resizing) return;
      img.style.width = startW + (e.clientX - startX) + "px";
      img.style.height = "auto";
    });
    document.addEventListener("mouseup", () => { resizing = false; });
  };

  // ── Selection popup ────────────────────────────────────────────────────────
  const clearSelectionPopupTimer = useCallback(() => {
    if (selectionPopupTimerRef.current) {
      clearTimeout(selectionPopupTimerRef.current);
      selectionPopupTimerRef.current = null;
    }
  }, []);

  const syncSelectionPopup = useCallback(() => {
    const sel = window.getSelection();

    if (!editor?.current || !sel || sel.rangeCount === 0) {
      setSelPopup((p) => ({ ...p, visible: false }));
      return;
    }

    const text = sel.toString().trim();
    if (!text || text.length <= 3) {
      setSelPopup((p) => ({ ...p, visible: false }));
      return;
    }

    try {
      const range = sel.getRangeAt(0);
      const anchorNode = range.commonAncestorContainer;
      const isInsideEditor = editor.current.contains(
        anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentNode : anchorNode,
      );

      if (!isInsideEditor) {
        setSelPopup((p) => ({ ...p, visible: false }));
        return;
      }

      const rect = range.getBoundingClientRect();
      const fallbackRect = range.getClientRects?.()[0];
      const targetRect = rect.width || rect.height ? rect : fallbackRect;

      if (!targetRect) {
        setSelPopup((p) => ({ ...p, visible: false }));
        return;
      }

      setSelPopup({
        visible: true,
        x: targetRect.left + targetRect.width / 2,
        y: targetRect.top,
        text,
      });
    } catch {
      setSelPopup((p) => ({ ...p, visible: false }));
    }
  }, [editor]);

  const scheduleSelectionPopupSync = useCallback((delay = 140) => {
    clearSelectionPopupTimer();
    selectionPopupTimerRef.current = setTimeout(() => {
      syncSelectionPopup();
    }, delay);
  }, [clearSelectionPopupTimer, syncSelectionPopup]);

  const handleMouseUp = () => {
    updateFormats();
    scheduleSelectionPopupSync();
  };

  const closePopup = useCallback(() => {
    clearSelectionPopupTimer();
    setSelPopup((p) => ({ ...p, visible: false }));
  }, [clearSelectionPopupTimer]);

  useEffect(() => {
    const handleSelectionChange = () => {
      scheduleSelectionPopupSync(160);
    };

    document.addEventListener("selectionchange", handleSelectionChange);
    return () => {
      document.removeEventListener("selectionchange", handleSelectionChange);
      clearSelectionPopupTimer();
    };
  }, [clearSelectionPopupTimer, scheduleSelectionPopupSync]);

  // ── Clipboard helpers ──────────────────────────────────────────────────────
  const handleFind  = () => { if (findText) window.find(findText); };
  const handleCopy  = () => document.execCommand("copy");
  const handlePaste = async () => {
    try { const t = await navigator.clipboard.readText(); exec("insertText", t); } catch {}
  };

  // ── Active check ───────────────────────────────────────────────────────────
  const isActive = (btn) => {
    if (!btn.ak) return false;
    if (btn.ak === "h1_heading") return activeHeadings.h1;
    if (btn.ak === "h2_heading") return activeHeadings.h2;
    return !!activeFormats[btn.ak];
  };

  // ── Toolbar groups ─────────────────────────────────────────────────────────
  const toolbarGroups = [
    [
      { icon: <UndoIcon />,  action: () => exec("undo"),  title: "Undo (Ctrl+Z)" },
      { icon: <RedoIcon />,  action: () => exec("redo"),  title: "Redo (Ctrl+Y)" },
    ],
    [
      { icon: <FormatBoldIcon />,        action: () => exec("bold"),        title: "Bold",         ak: "bold"        },
      { icon: <FormatItalicIcon />,      action: () => exec("italic"),      title: "Italic",       ak: "italic"      },
      { icon: <FormatUnderlinedIcon />,  action: () => exec("underline"),   title: "Underline",    ak: "underline"   },
      { icon: <StrikethroughSIcon />,    action: () => exec("strikeThrough"), title: "Strikethrough", ak: "strikeThrough" },
    ],
    [
      { icon: <SuperscriptIcon />, action: () => exec("superscript"), title: "Superscript", ak: "superscript" },
      { icon: <SubscriptIcon />,   action: () => exec("subscript"),   title: "Subscript",   ak: "subscript"   },
    ],
    [
      { icon: <FormatListBulletedIcon />, action: (e) => { e.preventDefault(); exec("insertUnorderedList"); }, title: "Bullet List",   ak: "insertUnorderedList" },
      { icon: <FormatListNumberedIcon />, action: (e) => { e.preventDefault(); exec("insertOrderedList");   }, title: "Numbered List", ak: "insertOrderedList"   },
    ],
    [
      { icon: <FormatIndentDecreaseIcon />, action: () => exec("outdent"), title: "Outdent" },
      { icon: <FormatIndentIncreaseIcon />, action: () => exec("indent"),  title: "Indent"  },
    ],
    [
      { icon: <FormatAlignLeftIcon />,    action: () => exec("justifyLeft"),   title: "Align Left"    },
      { icon: <FormatAlignCenterIcon />,  action: () => exec("justifyCenter"), title: "Align Center"  },
      { icon: <FormatAlignRightIcon />,   action: () => exec("justifyRight"),  title: "Align Right"   },
      { icon: <FormatAlignJustifyIcon />, action: () => exec("justifyFull"),   title: "Justify"       },
    ],
    [
      { icon: <LooksOneIcon />, action: () => formatH(1), title: "Heading 1", ak: "h1_heading" },
      { icon: <LooksTwoIcon />, action: () => formatH(2), title: "Heading 2", ak: "h2_heading" },
    ],
    [
      { icon: <LinkIcon />,         action: (e) => { e.preventDefault(); insertLink(); }, title: "Insert Link"  },
      { icon: <ImageIcon />,        action: (e) => { e.preventDefault(); insertImage(); }, title: "Insert Image" },
      { icon: <FormatClearIcon />,  action: (e) => { e.preventDefault(); exec("removeFormat"); }, title: "Clear Format" },
      { icon: <SearchIcon />,       action: () => setShowFindBar(!showFindBar), title: "Find (Ctrl+F)" },
      { icon: <ContentCopyIcon />,  action: handleCopy,  title: "Copy"  },
      { icon: <ContentPasteIcon />, action: handlePaste, title: "Paste" },
    ],
  ];

  // ── AI actions ─────────────────────────────────────────────────────────────
  const aiActions = [
    {
      icon: <AutoAwesomeIcon sx={{ fontSize: 17, color: C.accent }} />,
      label: "Generate",
      desc: "AI-powered content generation",
      iconBg: C.accentLight,
      onClick: null,
      disabled: false,
    },
    {
      icon: <AutoFixHighIcon sx={{ fontSize: 17, color: C.purple }} />,
      label: "Rewrite",
      desc: "Paraphrase & improve text",
      iconBg: C.purpleLight,
      onClick: handleParaphraseClick,
      disabled: !accessToParaphrase,
    },
    {
      icon: <AutoStoriesIcon sx={{ fontSize: 17, color: C.tealDark }} />,
      label: "Summarize",
      desc: "Condense your content",
      iconBg: C.tealLight,
      onClick: handleSummariserClick,
      disabled: !accessToSummarize,
    },
    ...(!isGrammarCheck ? [{
      icon: <Spellcheck sx={{ fontSize: 17, color: C.success }} />,
      label: "Grammar Check",
      desc: "Fix spelling & grammar",
      iconBg: C.successLight,
      onClick: grammarCheckClick,
      disabled: false,
    }] : []),
    ...(accessToOCR ? [{
      icon: <DocumentScannerIcon sx={{ fontSize: 17, color: C.warning }} />,
      label: "OCR Extract",
      desc: "Extract text from images",
      iconBg: C.warningLight,
      onClick: ocrCheck,
      disabled: false,
    }] : []),
  ];

  // ── Icon action buttons (bottom bar) ───────────────────────────────────────
  const iconActions = [
    { icon: <Delete sx={{ fontSize: 17 }} />,      title: "Delete",    onClick: handleDeleteFormain, disabled: !accessToDelete,   color: C.danger  },
    { icon: <UploadIcon sx={{ fontSize: 17 }} />,  title: "Upload",    onClick: handleFileChange,    disabled: !accessToUpload,   color: C.accent  },
    ...(docId ? [{ icon: <DownloadIcon sx={{ fontSize: 17 }} />, title: "Download", onClick: openDownloadModal, disabled: false, color: C.success }] : []),
    { icon: <ContentCopyIcon sx={{ fontSize: 17 }} />,  title: "Copy",      onClick: handleCopyFormain,   disabled: false,             color: C.accent  },
    { icon: <TranslateIcon sx={{ fontSize: 17 }} />,    title: "Translate", onClick: handleTranslateClick, disabled: !accessToTranslate, color: C.purple  },
    {
      icon: <MicIcon sx={{ fontSize: 17 }} />,
      title: isRecording ? "Stop Recording" : "Start Mic",
      onClick: handleMicClick,
      disabled: false,
      color: isRecording ? C.danger : C.textMuted,
      isRecording,
    },
  ];

  // ══════════════════════════════════════════════════════════════════════════
  // RENDER
  // ══════════════════════════════════════════════════════════════════════════
  return (
    <>
      {/* ── Global styles ── */}
      <style>{`
        @keyframes pulse {
          0%,100% { box-shadow: 0 0 0 0 rgba(239,91,91,0.35); }
          50%      { box-shadow: 0 0 0 7px rgba(239,91,91,0); }
        }
        .ce-area a { color: ${C.accent}; text-decoration: underline; }
        .ce-area h1 { font-size: 2em; font-weight: 700; margin: 0.5em 0; color: ${C.text}; }
        .ce-area h2 { font-size: 1.5em; font-weight: 600; margin: 0.5em 0; color: ${C.text}; }
        .ce-area img { max-width: 100%; height: auto; border-radius: ${R.md}; border: 1px solid ${C.border}; margin: 8px 0; }
        .ce-area img.selected { outline: 2px solid ${C.accent}; }
        .ce-area ul, .ce-area ol { padding-left: 1.5em; }
        .ce-area:empty::before {
          content: attr(data-placeholder);
          color: ${C.textMuted};
          font-style: italic;
          pointer-events: none;
        }
      `}</style>

      {/* ── Selection Popup ── */}
      {false && <SelectionPopup
        popup={selPopup}
        onClose={closePopup}
        onRewrite={handleParaphraseClick}
        onImprove={grammarCheckClick}
        onTone={handleTranslateClick}
      />}

      {/* ── Main Grid ── */}
      <Grid
        container
        spacing={2.5}
        alignItems="flex-start"
        sx={{ width: "100%", m: 0, minWidth: 0 }}
      >
        {/* ════════════════════════════════════════════════════════════════ */}
        {/* EDITOR COLUMN                                                    */}
        {/* ════════════════════════════════════════════════════════════════ */}
        <Grid
          xs={12}
          md={isEditorOnly && showAIPanel && !mobileView ? 8 : 12}
          sx={{ transition: "all 0.3s ease", minWidth: 0, width: "100%" }}
        >
          <EditorCard elevation={0}>

            {/* ── Toolbar ── */}
            {showtoolbar && !readOnly && (
              <Box
                sx={{
                  background: C.toolbar,
                  borderBottom: `1px solid ${C.border}`,
                  px: 1.5,
                  py: 0.85,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "3px",
                    rowGap: "4px",
                  }}
                >
                  {toolbarGroups.map((grp, gi) => (
                    <React.Fragment key={gi}>
                      {gi > 0 && <TDivider orientation="vertical" flexItem />}
                      <Box sx={{ display: "flex", gap: "2px", alignItems: "center" }}>
                        {grp.map((btn, bi) => (
                          <LightTooltip
                            key={bi}
                            title={btn.title}
                            placement="top"
                          >
                            <TBtn
                              $active={isActive(btn)}
                              onClick={btn.action}
                              size="small"
                            >
                              {btn.icon}
                            </TBtn>
                          </LightTooltip>
                        ))}
                      </Box>
                    </React.Fragment>
                  ))}

                  {/* More button */}
                  <TDivider orientation="vertical" flexItem />
                  <LightTooltip title="More options" placement="top">
                    <TBtn $active={false} size="small">
                      <AddIcon sx={{ fontSize: 16 }} />
                    </TBtn>
                  </LightTooltip>
                </Box>
              </Box>
            )}

            {/* ── Find Bar ── */}
            <Collapse in={showFindBar}>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  px: 2,
                  py: 1.2,
                  alignItems: "center",
                  background: C.warningLight,
                  borderBottom: `1px solid ${C.warningMid}`,
                }}
              >
                <SearchIcon sx={{ color: "#B8860B", fontSize: 17 }} />
                <TextField
                  size="small"
                  placeholder="Find text…"
                  value={findText}
                  onChange={(e) => setFindText(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleFind()}
                  sx={{
                    flex: 1,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: R.sm,
                      fontSize: "13px",
                      background: C.surface,
                      "& fieldset": { borderColor: C.warningMid },
                      "&.Mui-focused fieldset": { borderColor: "#C8A020" },
                    },
                  }}
                />
                <Button
                  size="small"
                  onClick={handleFind}
                  sx={{
                    borderRadius: R.sm,
                    textTransform: "none",
                    fontWeight: 600,
                    background: "#F0C040",
                    color: "#5A3800",
                    fontSize: "12px",
                    "&:hover": { background: "#E0B030" },
                  }}
                >
                  Find
                </Button>
                <IconButton
                  size="small"
                  onClick={() => setShowFindBar(false)}
                  sx={{ color: C.textMuted, "&:hover": { color: C.danger } }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            </Collapse>

            {/* ── Editor Content Area ── */}
            <Box
              ref={editor}
              className="ce-area"
              contentEditable={!readOnly}
              suppressContentEditableWarning
              onInput={!readOnly ? onChange : undefined}
              onKeyUp={updateFormats}
              onMouseUp={handleMouseUp}
              onClick={() => { if (!window.getSelection()?.toString()?.trim()) closePopup(); }}
              data-placeholder={placeholder || "Start typing your content…"}
              sx={{
                minHeight: editorMinH,
                maxHeight: editorMaxH,
                overflowX: "hidden",
                overflowY: "auto",
                padding: "28px 32px",
                outline: "none",
                fontSize: "15px",
                lineHeight: 1.85,
                color: C.text,
                fontFamily: "'Georgia', 'Times New Roman', serif",
                background: C.surface,
                caretColor: C.accent,
                cursor: readOnly ? "default" : "text",
                scrollbarWidth: "thin",
                scrollbarColor: `${C.border} transparent`,
                "&::-webkit-scrollbar": { width: "5px" },
                "&::-webkit-scrollbar-thumb": {
                  background: C.border,
                  borderRadius: "3px",
                },
              }}
            />

            {/* ── Bottom Status Bar ── */}
            <Box
              sx={{
                borderTop: `1px solid ${C.border}`,
                background: C.surfaceAlt,
                px: 2.5,
                py: 1.25,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                flexWrap: "wrap",
                gap: 1,
                borderRadius: `0 0 ${R.xl} ${R.xl}`,
              }}
            >
              {/* Right actions */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                {isEditorOnly &&
                  iconActions.map((a, i) => (
                    <LightTooltip key={i} title={a.title}>
                      <span>
                        <IconButton
                          onClick={a.onClick}
                          disabled={a.disabled}
                          size="small"
                          sx={{
                            width: 30,
                            height: 30,
                            borderRadius: R.sm,
                            color: a.color,
                            opacity: a.disabled ? 0.38 : 1,
                            transition: "all 0.14s",
                            ...(a.isRecording && {
                              background: C.dangerLight,
                              animation: `${pulseAnim} 1.2s ease-in-out infinite`,
                            }),
                            "&:hover:not(:disabled)": {
                              background: alpha(a.color || C.accent, 0.1),
                              transform: "translateY(-1px)",
                            },
                          }}
                        >
                          {a.icon}
                        </IconButton>
                      </span>
                    </LightTooltip>
                  ))}

                {isEditorOnly && (
                  <>
                    <Box
                      sx={{
                        width: 1,
                        height: 18,
                        background: C.border,
                        mx: 0.75,
                      }}
                    />
                    {/* AI Tools toggle */}
                    <Button
                      onClick={() => setShowAIPanel((p) => !p)}
                      startIcon={
                        <AutoAwesomeIcon sx={{ fontSize: "15px !important" }} />
                      }
                      sx={{
                        borderRadius: R.full,
                        textTransform: "none",
                        fontWeight: 700,
                        fontSize: "12px",
                        px: 1.75,
                        py: 0.6,
                        background: showAIPanel
                          ? `linear-gradient(135deg, ${C.accent}, ${C.purple})`
                          : C.accentLight,
                        color: showAIPanel ? "#fff" : C.accent,
                        border: `1.5px solid ${showAIPanel ? "transparent" : C.accentMid}`,
                        boxShadow: showAIPanel ? SHADOW.btn : "none",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          background: `linear-gradient(135deg, ${C.accent}, ${C.purple})`,
                          color: "#fff",
                          boxShadow: SHADOW.btn,
                          transform: "translateY(-1px)",
                        },
                      }}
                    >
                      AI Tools
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </EditorCard>
        </Grid>

        {/* ════════════════════════════════════════════════════════════════ */}
        {/* AI TOOLS PANEL                                                   */}
        {/* ════════════════════════════════════════════════════════════════ */}
        {isEditorOnly && showAIPanel && !mobileView && (
          <Grid xs={12} md={4} sx={{ transition: "all 0.3s ease", minWidth: 0, width: "100%" }}>
            <AICard elevation={0}>

              {/* ── Panel Header ── */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2.5,
                  py: 1.75,
                  borderBottom: `1px solid ${C.border}`,
                  background: C.surfaceAlt,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                  <Box
                    sx={{
                      width: 30,
                      height: 30,
                      borderRadius: R.md,
                      background: `linear-gradient(135deg, ${C.accent} 0%, ${C.purple} 100%)`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 10px rgba(91,111,232,0.3)",
                    }}
                  >
                    <AutoAwesomeIcon sx={{ fontSize: 16, color: "#fff" }} />
                  </Box>
                  <Typography
                    sx={{ fontWeight: 700, fontSize: "15px", color: C.text, letterSpacing: "-0.01em" }}
                  >
                    AI Tools
                  </Typography>
                </Box>
                <IconButton
                  size="small"
                  onClick={() => setShowAIPanel(false)}
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: R.sm,
                    color: C.textMuted,
                    border: `1px solid transparent`,
                    transition: "all 0.14s",
                    "&:hover": {
                      background: C.dangerLight,
                      color: C.danger,
                      border: `1px solid ${alpha(C.danger, 0.2)}`,
                    },
                  }}
                >
                  <CloseIcon sx={{ fontSize: 15 }} />
                </IconButton>
              </Box>

              {/* ── AI Actions ── */}
              <Box sx={{ px: 1.5, pt: 1.5, pb: 1 }}>
                {aiActions.map((a, i) => (
                  <AIActionRow
                    key={i}
                    onClick={a.disabled ? undefined : a.onClick}
                    sx={{ opacity: a.disabled ? 0.42 : 1, cursor: a.disabled ? "not-allowed" : "pointer" }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Box
                        sx={{
                          width: 34,
                          height: 34,
                          borderRadius: R.md,
                          background: a.iconBg,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          border: `1px solid ${C.border}`,
                        }}
                      >
                        {a.icon}
                      </Box>
                      <Box>
                        <Typography
                          sx={{ fontWeight: 600, fontSize: "13px", color: C.text, lineHeight: 1.2 }}
                        >
                          {a.label}
                        </Typography>
                        <Typography
                          sx={{ fontSize: "11px", color: C.textMuted, mt: 0.2 }}
                        >
                          {a.desc}
                        </Typography>
                      </Box>
                    </Box>
                    <ChevronRightIcon
                      className="chevron"
                      sx={{ fontSize: 17, color: C.textMuted, flexShrink: 0 }}
                    />
                  </AIActionRow>
                ))}
              </Box>

              <Divider sx={{ borderColor: C.border, mx: 2 }} />

              {/* ── Chapters ── */}
              <Box sx={{ px: 2, py: 1.5 }}>
                <Box
                  onClick={() => setChaptersOpen((p) => !p)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    mb: chaptersOpen ? 1.25 : 0,
                    px: 0.5,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <MenuBookIcon sx={{ fontSize: 15, color: C.purple }} />
                    <Typography
                      sx={{ fontWeight: 700, fontSize: "12.5px", color: C.text }}
                    >
                      Chapters
                    </Typography>
                    {chapters.length > 0 && (
                      <Chip
                        label={chapters.length}
                        size="small"
                        sx={{
                          height: 18,
                          fontSize: "10px",
                          fontWeight: 700,
                          bgcolor: C.purpleLight,
                          color: C.purple,
                          "& .MuiChip-label": { px: 0.75 },
                        }}
                      />
                    )}
                  </Box>
                  <ExpandMoreIcon
                    sx={{
                      fontSize: 17,
                      color: C.textMuted,
                      transform: chaptersOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </Box>

                <Collapse in={chaptersOpen}>
                  {chapters.length > 0 ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
                      {chapters.map((ch, i) => (
                        <Box
                          key={ch.id}
                          onClick={() => setActiveChapter(i)}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.25,
                            py: 0.9,
                            px: 1.25,
                            borderRadius: R.md,
                            cursor: "pointer",
                            background: i === activeChapter ? C.accentLight : "transparent",
                            border: `1px solid ${i === activeChapter ? C.accentMid : "transparent"}`,
                            transition: "all 0.14s",
                            "&:hover": {
                              background: i === activeChapter ? C.accentLight : C.surfaceAlt,
                            },
                          }}
                        >
                          <Box
                            sx={{
                              width: 5,
                              height: 5,
                              borderRadius: "50%",
                              background: i === activeChapter ? C.accent : C.border,
                              flexShrink: 0,
                              transition: "background 0.14s",
                            }}
                          />
                          <Typography
                            noWrap
                            sx={{
                              fontSize: "12.5px",
                              fontWeight: i === activeChapter ? 700 : 500,
                              color: i === activeChapter ? C.accent : C.textSub,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {ch.title}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        textAlign: "center",
                        py: 2,
                        px: 1,
                        borderRadius: R.md,
                        background: C.surfaceAlt,
                        border: `1px dashed ${C.border}`,
                      }}
                    >
                      <MenuBookIcon sx={{ fontSize: 20, color: C.border, mb: 0.5 }} />
                      <Typography
                        sx={{ fontSize: "11.5px", color: C.textMuted, fontStyle: "italic" }}
                      >
                        Add headings to see chapters
                      </Typography>
                    </Box>
                  )}
                </Collapse>
              </Box>

              <Divider sx={{ borderColor: C.border, mx: 2 }} />

              {/* ── Stats ── */}
              <Box sx={{ px: 2, py: 1.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                  <TuneIcon sx={{ fontSize: 15, color: C.accent }} />
                  <Typography sx={{ fontWeight: 700, fontSize: "12.5px", color: C.text }}>
                    Stats
                  </Typography>
                </Box>
                <Grid container spacing={1}>
                  <Grid xs={4}>
                    <StatBox $bg={C.accentLight} $color={C.accent} $border={C.accentMid}>
                      <Typography sx={{ fontWeight: 800, fontSize: "18px", color: C.accent, lineHeight: 1 }}>
                        {totalWords ?? 0}
                      </Typography>
                      <Typography sx={{ fontSize: "10px", color: C.textMuted, fontWeight: 500, mt: 0.5 }}>
                        Words
                      </Typography>
                    </StatBox>
                  </Grid>
                  <Grid xs={4}>
                    <StatBox $bg={C.purpleLight} $color={C.purple} $border={C.purpleMid}>
                      <Typography sx={{ fontWeight: 800, fontSize: "18px", color: C.purple, lineHeight: 1 }}>
                        {readTime}m
                      </Typography>
                      <Typography sx={{ fontSize: "10px", color: C.textMuted, fontWeight: 500, mt: 0.5 }}>
                        Read
                      </Typography>
                    </StatBox>
                  </Grid>
                  <Grid xs={4}>
                    <StatBox $bg={C.tealLight} $color={C.tealDark} $border="rgba(78,205,196,0.25)">
                      <Typography sx={{ fontWeight: 800, fontSize: "17px", color: C.tealDark, lineHeight: 1 }}>
                        {charCount >= 1000 ? (charCount / 1000).toFixed(1) + "k" : charCount}
                      </Typography>
                      <Typography sx={{ fontSize: "10px", color: C.textMuted, fontWeight: 500, mt: 0.5 }}>
                        Chars
                      </Typography>
                    </StatBox>
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ borderColor: C.border, mx: 2 }} />

              {/* ── Writing Mode ── */}
              <Box sx={{ px: 2, py: 1.75 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "10.5px",
                    color: C.textMuted,
                    mb: 1.25,
                    textTransform: "uppercase",
                    letterSpacing: "0.09em",
                  }}
                >
                  Writing Mode
                </Typography>
                <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
                  {["balanced", "creative", "formal"].map((mode) => (
                    <ModeBtn
                      key={mode}
                      $selected={writingMode === mode}
                      onClick={() => setWritingMode(mode)}
                      size="small"
                    >
                      {mode.charAt(0).toUpperCase() + mode.slice(1)}
                    </ModeBtn>
                  ))}
                </Box>
              </Box>

            </AICard>
          </Grid>
        )}
      </Grid>
    </>
  );
}

